var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325.24,
    y: 244.96,
    width: 112.22,
    height: 218.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.62,454.58s0-.33,0-1,0-1.6,0-2.85c0-2.52,0-6.23,0-11,0-9.63,0-23.67-.07-41.35,0-35.32-.07-85.15-.12-143.25l.25.25-94.95,0h0l.26-.27c0,77.24-.05,147.52-.07,199.47l-.19-.19,69.41.1,18.92.05,4.94,0,1.69,0-1.65,0-4.9,0-18.88.05-69.53.11h-.2v-.2c0-51.95,0-122.23-.07-199.47v-.26h95.49v.25c0,58.16-.09,108.06-.11,143.42,0,17.65-.06,31.67-.07,41.29,0,4.79,0,8.48,0,11,0,1.24,0,2.18,0,2.82S428.62,454.58,428.62,454.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.25,
    y: 287.5,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.25,
    y: 393.56,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.92,381.83s0-.08,0-.23,0-.39,0-.65c0-.61,0-1.44,0-2.49,0-2.18,0-5.29-.07-9.14,0-7.75-.07-18.52-.12-30.73l.26.26h-8.33c.52-.53.14-.14.26-.26v6.69q0,3.29,0,6.44c0,4.19,0,8.17,0,11.87,0,7.38-.07,13.64-.09,18.23l-.14-.14,6.11.08,1.64,0,.58,0a3.28,3.28,0,0,1-.53,0l-1.61,0-6.19.08h-.15v-.15c0-4.59-.05-10.85-.09-18.23,0-3.7,0-7.68,0-11.87q0-3.15,0-6.44V338.6c.12-.12-.27.26.27-.27h8.59v.26c0,12.29-.08,23.11-.11,30.92,0,3.82-.06,6.91-.08,9.08,0,1,0,1.83,0,2.42S352.93,381.84,352.92,381.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,418c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S412.81,417.85,412.81,418Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,425.19c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S412.81,425,412.81,425.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,432.38c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S412.81,432.24,412.81,432.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,275c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S412.81,274.9,412.81,275Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,282.24c0,.15-13.77.26-30.75.26s-30.76-.11-30.76-.26,13.77-.27,30.76-.27S412.81,282.09,412.81,282.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,289.44c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S412.81,289.29,412.81,289.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.83,
    y: 26.25,
    width: 112.22,
    height: 218.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.22,235.87s0-.34,0-1,0-1.6,0-2.86c0-2.51,0-6.22,0-11,0-9.63,0-23.67-.07-41.34,0-35.32-.07-85.16-.12-143.25l.25.25h-95l.26-.26c0,77.24,0,147.52-.07,199.47l-.19-.2,69.41.11,18.92.05,4.94,0c1.11,0,1.69,0,1.69,0l-1.65,0-4.9,0-18.89.05-69.52.1h-.2v-.19c0-52,0-122.23-.07-199.47v-.27h.28l95,0h.25v.25c-.05,58.16-.09,108-.12,143.42,0,17.65,0,31.67-.07,41.29,0,4.79,0,8.48,0,11,0,1.24,0,2.19,0,2.83S204.22,235.87,204.22,235.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.84,
    y: 68.79,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.84,
    y: 174.85,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.52,163.12a1.35,1.35,0,0,1,0-.24c0-.17,0-.39,0-.65,0-.61,0-1.43,0-2.48,0-2.19,0-5.29-.08-9.14,0-7.76-.07-18.52-.11-30.73l.26.26h-8.33c.52-.53.14-.13.26-.25h0v6.67c0,2.2,0,4.34,0,6.44,0,4.19,0,8.17,0,11.88,0,7.37-.07,13.63-.09,18.23l-.14-.15,6.11.08,1.64,0,.58,0s-.17,0-.53,0l-1.61,0-6.19.08H120v-.14c0-4.6-.05-10.86-.09-18.23,0-3.71,0-7.69,0-11.88,0-2.1,0-4.24,0-6.44V119.9h0c.12-.12-.27.25.27-.28h8.59v.26c0,12.28-.09,23.11-.11,30.91,0,3.83-.06,6.91-.08,9.08,0,1,0,1.84,0,2.43A8.1,8.1,0,0,1,128.52,163.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,199.28c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S188.41,199.13,188.41,199.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,206.47c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S188.41,206.33,188.41,206.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,213.67c0,.15-13.77.26-30.75.26s-30.76-.11-30.76-.26,13.77-.27,30.76-.27S188.41,213.52,188.41,213.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,56.33c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.27,30.76-.27S188.41,56.18,188.41,56.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,63.53c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S188.41,63.38,188.41,63.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,70.72c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S188.41,70.58,188.41,70.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.06,
    y: 26.25,
    width: 112.22,
    height: 218.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.45,235.87s0-.34,0-1,0-1.6,0-2.86c0-2.51,0-6.22,0-11,0-9.63,0-23.67-.07-41.34,0-35.32-.07-85.16-.12-143.25l.26.25h-95l.26-.26c0,77.24-.05,147.52-.07,199.47l-.19-.2,69.41.11,18.92.05,4.94,0c1.11,0,1.7,0,1.7,0l-1.66,0-4.9,0L291,236l-69.53.1h-.2v-.19c0-52,0-122.23-.07-199.47v-.27h.28l95,0h.25v.25c-.05,58.16-.09,108-.12,143.42,0,17.65-.06,31.67-.07,41.29,0,4.79,0,8.48,0,11,0,1.24,0,2.19,0,2.83S316.45,235.87,316.45,235.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.07,
    y: 68.79,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.07,
    y: 174.85,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.74,163.12s0-.09,0-.24,0-.39,0-.65c0-.61,0-1.43,0-2.48,0-2.19,0-5.29-.07-9.14,0-7.76-.07-18.52-.12-30.73l.26.26h-8.33c.53-.53.15-.13.26-.25h0v6.67c0,2.2,0,4.34,0,6.44,0,4.19,0,8.17,0,11.88,0,7.37-.07,13.63-.09,18.23l-.14-.15,6.11.08,1.64,0,.58,0s-.17,0-.53,0l-1.6,0-6.2.08h-.15v-.14c0-4.6,0-10.86-.08-18.23,0-3.71,0-7.69,0-11.88v-6.44c0-1.09,0-2.2,0-3.32V119.9h0c.12-.12-.26.25.27-.28H241v.26c0,12.28-.08,23.11-.11,30.91,0,3.83-.06,6.91-.08,9.08q0,1.55,0,2.43A6.09,6.09,0,0,1,240.74,163.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,199.28c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S300.63,199.13,300.63,199.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,206.47c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S300.63,206.33,300.63,206.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,213.67c0,.15-13.77.26-30.75.26s-30.76-.11-30.76-.26,13.77-.27,30.76-.27S300.63,213.52,300.63,213.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,56.33c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.27,30.76-.27S300.63,56.18,300.63,56.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,63.53c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S300.63,63.38,300.63,63.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,70.72c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S300.63,70.58,300.63,70.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.24,
    y: 26.25,
    width: 112.22,
    height: 218.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.62,235.87s0-.34,0-1,0-1.6,0-2.86c0-2.51,0-6.22,0-11,0-9.63,0-23.67-.07-41.34,0-35.32-.07-85.16-.12-143.25l.25.25h-95l.26-.26c0,77.24-.05,147.52-.07,199.47l-.19-.2,69.41.11,18.92.05,4.94,0c1.11,0,1.69,0,1.69,0l-1.65,0-4.9,0-18.88.05-69.53.1h-.2v-.19c0-52,0-122.23-.07-199.47v-.27h.28l94.95,0h.26v.25c0,58.16-.09,108-.11,143.42,0,17.65-.06,31.67-.07,41.29,0,4.79,0,8.48,0,11,0,1.24,0,2.19,0,2.83S428.62,235.87,428.62,235.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.25,
    y: 68.79,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.25,
    y: 174.85,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.92,163.12s0-.09,0-.24,0-.39,0-.65c0-.61,0-1.43,0-2.48,0-2.19,0-5.29-.07-9.14,0-7.76-.07-18.52-.12-30.73l.26.26h-8.33c.52-.53.14-.13.26-.25h0v6.67c0,2.2,0,4.34,0,6.44,0,4.19,0,8.17,0,11.88,0,7.37-.07,13.63-.09,18.23l-.14-.15,6.11.08,1.64,0,.58,0s-.17,0-.53,0l-1.61,0-6.19.08h-.15v-.14c0-4.6-.05-10.86-.09-18.23,0-3.71,0-7.69,0-11.88,0-2.1,0-4.24,0-6.44V119.9h0c.12-.12-.27.25.27-.28h8.59v.26c0,12.28-.08,23.11-.11,30.91,0,3.83-.06,6.91-.08,9.08,0,1,0,1.84,0,2.43S352.93,163.13,352.92,163.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,199.28c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S412.81,199.13,412.81,199.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,206.47c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S412.81,206.33,412.81,206.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,213.67c0,.15-13.77.26-30.75.26s-30.76-.11-30.76-.26,13.77-.27,30.76-.27S412.81,213.52,412.81,213.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,56.33c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.27,30.76-.27S412.81,56.18,412.81,56.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,63.53c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S412.81,63.38,412.81,63.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,70.72c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S412.81,70.58,412.81,70.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.83,
    y: 244.96,
    width: 112.22,
    height: 218.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.22,454.58s0-.33,0-1,0-1.6,0-2.85c0-2.52,0-6.23,0-11,0-9.63,0-23.67-.07-41.35,0-35.32-.07-85.15-.12-143.25l.25.25-94.95,0h0l.26-.27c0,77.24,0,147.52-.07,199.47l-.19-.19,69.41.1,18.92.05,4.94,0,1.69,0-1.65,0-4.9,0-18.89.05-69.52.11h-.2v-.2c0-51.95,0-122.23-.07-199.47v-.26h95.48v.25c-.05,58.16-.09,108.06-.12,143.42,0,17.65,0,31.67-.07,41.29,0,4.79,0,8.48,0,11,0,1.24,0,2.18,0,2.82S204.22,454.58,204.22,454.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.84,
    y: 287.5,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.84,
    y: 393.56,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.52,381.83a1.17,1.17,0,0,1,0-.23c0-.18,0-.39,0-.65,0-.61,0-1.44,0-2.49,0-2.18,0-5.29-.08-9.14,0-7.75-.07-18.52-.11-30.73l.26.26h-8.33c.52-.53.14-.14.26-.26v6.69c0,2.19,0,4.34,0,6.44,0,4.19,0,8.17,0,11.87,0,7.38-.07,13.64-.09,18.23l-.14-.14,6.11.08,1.64,0,.58,0a3.28,3.28,0,0,1-.53,0l-1.61,0-6.19.08H120v-.15c0-4.59-.05-10.85-.09-18.23,0-3.7,0-7.68,0-11.87,0-2.1,0-4.25,0-6.44V338.6c.12-.12-.27.26.27-.27h8.59v.26c0,12.29-.09,23.11-.11,30.92,0,3.82-.06,6.91-.08,9.08,0,1,0,1.83,0,2.42A8.1,8.1,0,0,1,128.52,381.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,418c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S188.41,417.85,188.41,418Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,425.19c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S188.41,425,188.41,425.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,432.38c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S188.41,432.24,188.41,432.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,275c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S188.41,274.9,188.41,275Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,282.24c0,.15-13.77.26-30.75.26s-30.76-.11-30.76-.26,13.77-.27,30.76-.27S188.41,282.09,188.41,282.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,289.44c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S188.41,289.29,188.41,289.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.06,
    y: 244.96,
    width: 112.22,
    height: 218.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.45,454.58s0-.33,0-1,0-1.6,0-2.85c0-2.52,0-6.23,0-11,0-9.63,0-23.67-.07-41.35,0-35.32-.07-85.15-.12-143.25l.26.25-95,0h0l.26-.27c0,77.24-.05,147.52-.07,199.47l-.19-.19,69.41.1,18.92.05,4.94,0,1.7,0-1.66,0-4.9,0-18.88.05-69.53.11h-.2v-.2c0-51.95,0-122.23-.07-199.47v-.26H316.7v.25c-.05,58.16-.09,108.06-.12,143.42,0,17.65-.06,31.67-.07,41.29,0,4.79,0,8.48,0,11,0,1.24,0,2.18,0,2.82S316.45,454.58,316.45,454.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.07,
    y: 287.5,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.07,
    y: 393.56,
    width: 6.76,
    height: 33.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.74,381.83s0-.08,0-.23,0-.39,0-.65c0-.61,0-1.44,0-2.49,0-2.18,0-5.29-.07-9.14,0-7.75-.07-18.52-.12-30.73l.26.26h-8.33l.26-.26v6.69q0,3.29,0,6.44c0,4.19,0,8.17,0,11.87,0,7.38-.07,13.64-.09,18.23l-.14-.14,6.11.08,1.64,0,.58,0a3.28,3.28,0,0,1-.53,0l-1.6,0-6.2.08h-.15v-.15c0-4.59,0-10.85-.08-18.23,0-3.7,0-7.68,0-11.87v-6.44c0-1.1,0-2.2,0-3.32V338.6l.27-.27H241v.26c0,12.29-.08,23.11-.11,30.92,0,3.82-.06,6.91-.08,9.08,0,1,0,1.83,0,2.42A6.09,6.09,0,0,1,240.74,381.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,418c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S300.63,417.85,300.63,418Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,425.19c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S300.63,425,300.63,425.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,432.38c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S300.63,432.24,300.63,432.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,275c0,.15-13.77.27-30.75.27s-30.76-.12-30.76-.27,13.77-.26,30.76-.26S300.63,274.9,300.63,275Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,282.24c0,.15-13.77.26-30.75.26s-30.76-.11-30.76-.26,13.77-.27,30.76-.27S300.63,282.09,300.63,282.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,289.44c0,.14-13.77.26-30.75.26s-30.76-.12-30.76-.26,13.77-.27,30.76-.27S300.63,289.29,300.63,289.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,112.22a2.44,2.44,0,0,1,.14-.53c.12-.4.27-.9.46-1.51.39-1.3,1-3.2,1.53-5.6.29-1.2.59-2.52.86-4l.39-2.22a6.66,6.66,0,0,0,.11-2.31,1.83,1.83,0,0,0-1.41-1.58,2.89,2.89,0,0,0-2.29.6,4,4,0,0,0-1.28,2.2,14,14,0,0,0-.31,2.79l0,.51-.41-.31a12,12,0,0,1-2.31-2.65,16.29,16.29,0,0,0-1.94-2.43,5.25,5.25,0,0,0-2.57-1.3,2.57,2.57,0,0,0-2.48.72,2.88,2.88,0,0,0-.55,2.46c.36,1.74,1.75,3,2.82,4.2l3.09,3.38,4.45,4.92,1.19,1.35a2.81,2.81,0,0,1,.38.5,3,3,0,0,1-.46-.42l-1.26-1.29-4.57-4.81c-1-1-2-2.14-3.14-3.34-.56-.6-1.16-1.2-1.72-1.91a5.82,5.82,0,0,1-1.26-2.49,3.4,3.4,0,0,1,.65-2.89,3.11,3.11,0,0,1,2.95-.89,5.74,5.74,0,0,1,2.84,1.43,16.55,16.55,0,0,1,2,2.5,11.48,11.48,0,0,0,2.21,2.54l-.43.2a13.35,13.35,0,0,1,.34-2.89,4.44,4.44,0,0,1,1.47-2.48,3.35,3.35,0,0,1,2.7-.68A2.34,2.34,0,0,1,282,96a7.17,7.17,0,0,1-.14,2.47c-.13.77-.27,1.52-.42,2.24-.29,1.43-.61,2.75-.92,4-.63,2.39-1.24,4.28-1.7,5.57-.23.65-.41,1.15-.55,1.48A2.08,2.08,0,0,1,278,112.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.06,115.5c.05.14-4.84,1.86-10.92,3.84s-11,3.47-11.09,3.33,4.85-1.86,10.92-3.84S291,115.36,291.06,115.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.67,130.53a19.37,19.37,0,0,1,2.25-3.93,19.36,19.36,0,0,1,2.69-3.65,19.58,19.58,0,0,1-2.25,3.94A19.48,19.48,0,0,1,277.67,130.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.2,128.71a23.89,23.89,0,0,1-4.83-1.45,24.31,24.31,0,0,1-4.65-2,23.57,23.57,0,0,1,4.83,1.46A24.69,24.69,0,0,1,284.2,128.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,128a21.27,21.27,0,0,1-3.1,1.56c-1.95.89-4.68,2-7.73,3.23s-5.85,2.14-7.9,2.8a20,20,0,0,1-3.34.92,24,24,0,0,1,3.22-1.28c2-.74,4.78-1.76,7.83-2.94s5.78-2.28,7.77-3.08A23.44,23.44,0,0,1,296,128Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.38,349.48c-.15,0,1.13-7.62,2.84-17s3.22-16.89,3.36-16.87-1.12,7.62-2.84,17S156.52,349.51,156.38,349.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,357.18c-.15,0,1.46-8.32,3.58-18.51s3.95-18.44,4.09-18.41-1.46,8.32-3.58,18.51S162.17,357.21,162,357.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.05,371.55c-.14-.05,2.85-10.41,6.68-23.15s7.05-23,7.19-23-2.85,10.4-6.68,23.14S163.19,371.59,163.05,371.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.06,376.12c-.15,0,1.7-8,4.12-17.74s4.49-17.66,4.64-17.62-1.71,8-4.13,17.74S168.2,376.16,168.06,376.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.15,364.35c-.11.09-6-7.27-13.1-16.44s-12.8-16.68-12.69-16.77,6,7.27,13.11,16.44S173.27,364.26,173.15,364.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.24,362.81c-.12.08-4.73-7.18-10.29-16.22s-10-16.43-9.85-16.5,4.74,7.18,10.3,16.22S177.37,362.74,177.24,362.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.36,354.59a11.2,11.2,0,0,1-1-1.52l-2.47-4.21c-2.1-3.54-5.07-8.4-8.54-13.64s-6.78-9.87-9.23-13.18c-1.18-1.6-2.16-2.93-2.9-3.92a13.93,13.93,0,0,1-1-1.47,10.25,10.25,0,0,1,1.19,1.34c.74.88,1.78,2.19,3,3.82,2.53,3.26,5.9,7.87,9.38,13.12s6.39,10.15,8.41,13.75c1,1.8,1.81,3.26,2.33,4.29A12.49,12.49,0,0,1,180.36,354.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.58,107.64s0,.19-.12.54-.19.89-.4,1.58a19.24,19.24,0,0,1-2.93,5.49,21.76,21.76,0,0,1-7.63,6.19,21.34,21.34,0,0,1-5.88,1.87,17.65,17.65,0,0,1-6.92-.2,8.17,8.17,0,0,1-3.43-1.54,5.28,5.28,0,0,1-2.22-3.25,3,3,0,0,1,2.3-3.23,6.06,6.06,0,0,1,4.17.82c5,3.16,7.33,10.17,5.31,16.38a13.1,13.1,0,0,1-6.29,7.47,15.12,15.12,0,0,1-10.09,1.62,11.8,11.8,0,0,1-8.48-6.15,7.35,7.35,0,0,1-.36-5.47,5.93,5.93,0,0,1,3.84-4,7.05,7.05,0,0,1,5.5.82,9.93,9.93,0,0,1,3.78,4,22.85,22.85,0,0,1,1.91,5.06c.45,1.72.87,3.42,1.22,5.13.7,3.4,1,7-.08,10.26a10.77,10.77,0,0,1-2.73,4.23,12.53,12.53,0,0,1-4.18,2.6,15.15,15.15,0,0,1-9.33.35,22.83,22.83,0,0,1-7.93-3.92c-2.26-1.72-4.15-4.13-4.34-6.91a6.86,6.86,0,0,1,.85-3.84,4.9,4.9,0,0,1,2.94-2.35,5.31,5.31,0,0,1,3.57.34,8.6,8.6,0,0,1,2.74,2,9.59,9.59,0,0,1,1.77,2.68,12.66,12.66,0,0,1,.83,2.9,14.59,14.59,0,0,1-1.84,9.57,13.61,13.61,0,0,1-4.19,4.58c-.3.2-.56.38-.79.51l-.61.31c-.33.17-.5.24-.5.24s.16-.11.47-.29l.59-.33c.23-.14.48-.33.78-.52a13.92,13.92,0,0,0,4.07-4.6,14.38,14.38,0,0,0,1.73-9.42,12.55,12.55,0,0,0-.83-2.82,9.53,9.53,0,0,0-1.72-2.58,8.2,8.2,0,0,0-2.64-1.92,4.89,4.89,0,0,0-3.33-.31,4.52,4.52,0,0,0-2.7,2.18,6.62,6.62,0,0,0-.79,3.63c.19,2.59,2,4.91,4.2,6.58a22.76,22.76,0,0,0,7.79,3.82,14.67,14.67,0,0,0,9-.35,12.17,12.17,0,0,0,4-2.51,10.2,10.2,0,0,0,2.6-4c1.07-3.12.75-6.62,0-10-.34-1.7-.77-3.4-1.22-5.11a21.74,21.74,0,0,0-1.86-4.93,9.4,9.4,0,0,0-3.58-3.79,6.51,6.51,0,0,0-5.08-.77,5.39,5.39,0,0,0-3.5,3.63,6.85,6.85,0,0,0,.34,5.09,11.34,11.34,0,0,0,8.1,5.87,14.69,14.69,0,0,0,9.75-1.56,12.67,12.67,0,0,0,6.07-7.18,14.69,14.69,0,0,0,0-9,12.69,12.69,0,0,0-5-6.8,5.54,5.54,0,0,0-3.86-.79,2.54,2.54,0,0,0-2,2.76,4.89,4.89,0,0,0,2,3,7.64,7.64,0,0,0,3.27,1.48,17.35,17.35,0,0,0,6.78.24,21.43,21.43,0,0,0,5.82-1.8,21.85,21.85,0,0,0,7.59-6.06,19.89,19.89,0,0,0,3-5.4c.22-.67.34-1.2.45-1.55S189.58,107.64,189.58,107.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.57,153.81a18.23,18.23,0,0,1-3.46,2,25.94,25.94,0,0,1-10.57,2.32,23.9,23.9,0,0,1-3.61-.23,8.58,8.58,0,0,1-3.72-1.33,4.54,4.54,0,0,1-2-3.72,3.33,3.33,0,0,1,.9-2.11,4.34,4.34,0,0,1,2-1.21,4.83,4.83,0,0,1,2.39-.09,5.14,5.14,0,0,1,2.18,1.11,8.47,8.47,0,0,1,2.56,4.2,13.24,13.24,0,0,1-1.28,10,12.73,12.73,0,0,1-8.15,6,12,12,0,0,1-4.92.13,7.54,7.54,0,0,1-4.18-2.18,4.42,4.42,0,0,1-1-4.34,3.75,3.75,0,0,1,1.19-1.87,3.1,3.1,0,0,1,2-.69,4.29,4.29,0,0,1,3.36,2.07,7.29,7.29,0,0,1,1,3.52,17.12,17.12,0,0,1-3.08,10.29,13.3,13.3,0,0,1-2.68,2.94,6.78,6.78,0,0,1,.69-.76,17.79,17.79,0,0,0,1.82-2.3,17.14,17.14,0,0,0,2.87-10.15,6.9,6.9,0,0,0-.95-3.32,3.86,3.86,0,0,0-3-1.85,2.61,2.61,0,0,0-1.75.6,3.37,3.37,0,0,0-1,1.65,4,4,0,0,0,.91,3.88,7,7,0,0,0,3.92,2,11.49,11.49,0,0,0,4.7-.14,12.19,12.19,0,0,0,7.81-5.74,12.81,12.81,0,0,0,1.25-9.64,8,8,0,0,0-2.39-4,4.78,4.78,0,0,0-2-1,4.31,4.31,0,0,0-2.14.08,3.29,3.29,0,0,0-2.57,2.88,4.07,4.07,0,0,0,1.8,3.33,8.21,8.21,0,0,0,3.53,1.29,25.79,25.79,0,0,0,3.54.26A26.46,26.46,0,0,0,186,155.58c1.18-.49,2-1,2.64-1.28l.67-.38C189.48,153.84,189.56,153.8,189.57,153.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.23,120.24a1.3,1.3,0,0,1,0-.23c0-.18,0-.39,0-.66,0-.6,0-1.43,0-2.5,0-2.2,0-5.36-.08-9.35l.15.15-48.14.1.25-.25h0V114q0,3.19,0,6.27l-.24-.24,34.3.11,10.13.06,2.74,0H85l.26,0H85l-.68,0-2.69,0-10.07.07-34.47.11h-.24v-13h0l.24-.24,48.14.09h.15v.15c0,4-.07,7.22-.09,9.43,0,1.06,0,1.89,0,2.48,0,.25,0,.46,0,.62A1.66,1.66,0,0,1,85.23,120.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.26,139.38a1.35,1.35,0,0,1,0-.24c0-.17,0-.38,0-.65,0-.6,0-1.43,0-2.5,0-2.2-.05-5.36-.08-9.35l.15.15-48.13.1c.11-.11-.25.24.24-.25h0v6.45q0,3.19,0,6.27l-.24-.24,34.31.11,10.12.06,2.74,0,.72,0,.25,0H713l-.69,0-2.69,0-10.07.07-34.47.11h-.24v-13h0c.49-.49.14-.13.25-.24l48.13.09h.15v.15c0,4-.07,7.21-.08,9.43,0,1.06,0,1.89,0,2.48,0,.25,0,.46,0,.62A1.66,1.66,0,0,1,713.26,139.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.56,177.85a1,1,0,0,1,0-.23c0-.17,0-.38,0-.65,0-.6,0-1.44,0-2.51,0-2.2,0-5.36-.08-9.34l.15.15-48.13.09.24-.24h0v6.45c0,2.12,0,4.22,0,6.26l-.23-.24,34.3.11,10.12.07,2.74,0,.72,0h.25a.89.89,0,0,1-.22,0h-.69l-2.69,0-10.07.06-34.46.11h-.24v-.24c0-2,0-4.14,0-6.26v-6.45h0l.25-.25,48.13.1h.15v.15c0,4-.06,7.21-.08,9.43,0,1.06,0,1.88,0,2.47,0,.26,0,.47,0,.63A1.23,1.23,0,0,1,486.56,177.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.09,165.12a.73.73,0,0,1,0-.24c0-.19,0-.41,0-.68,0-.62,0-1.48-.05-2.55,0-2.23-.05-5.39-.09-9.26l.18.17-28.92.07c-.22.22.29-.3.24-.24h0v6.53c0,2.13,0,4.2,0,6.18l-.24-.23,20.69.11,6,.06,1.62,0,.59,0a3.28,3.28,0,0,1-.53,0l-1.58,0-6,.06-20.85.11h-.23v-.23c0-2,0-4.05,0-6.18v-6.53h0c-.05.05.46-.47.25-.25l28.92.07h.17v.18c0,3.92-.07,7.11-.09,9.37,0,1.05,0,1.89-.05,2.51S493.1,165.13,493.09,165.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.91,393.48a1.17,1.17,0,0,1,0-.23c0-.17,0-.39,0-.65,0-.6,0-1.44,0-2.51,0-2.2,0-5.36-.08-9.34l.15.15L46.78,381l.24-.24h0v6.45c0,2.12,0,4.21,0,6.26l-.24-.24,34.3.11,10.13.07,2.74,0h.71l.26,0-.23,0H94l-2.69,0-10.07.07-34.47.11h-.24v-13h0l.25-.25,48.13.1h.15v.15c0,4-.07,7.21-.09,9.43,0,1.06,0,1.88,0,2.47,0,.26,0,.46,0,.63A1.39,1.39,0,0,1,94.91,393.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.43,380.75s0-.09,0-.25,0-.4,0-.67c0-.63,0-1.48-.05-2.55,0-2.24,0-5.39-.09-9.27l.17.18-28.92.07.25-.25h0v3.31c0,1.1,0,2.18,0,3.24v6.18l-.24-.24,20.69.11,6,.07,1.62,0,.58,0a2.78,2.78,0,0,1-.52,0l-1.58,0-6,.07L72.51,381h-.23v-.23c0-2,0-4.05,0-6.18V368h0l.24-.24,28.92.07h.18V368c0,3.92-.07,7.11-.1,9.37,0,1.06,0,1.9,0,2.52A4.8,4.8,0,0,1,101.43,380.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.3,71.19a1,1,0,0,1,0-.23c0-.17,0-.38,0-.65,0-.6,0-1.44,0-2.51,0-2.2-.05-5.36-.08-9.34l.15.15-48.14.09c.11-.1-.24.25.25-.24h0v3.24c0,1.08,0,2.15,0,3.21v6.26l-.24-.24,34.3.11,10.13.07,2.74,0,.71,0h.26a.94.94,0,0,1-.23,0h-.68l-2.69,0-10.07.06-34.47.11h-.24v-13h0c.49-.49.13-.14.24-.25l48.14.1h.15v.15c0,4-.06,7.21-.08,9.43,0,1.06,0,1.88,0,2.47,0,.26,0,.47,0,.63A1.23,1.23,0,0,1,563.3,71.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.82,58.46s0-.09,0-.24,0-.41,0-.68c0-.62,0-1.48,0-2.55,0-2.23,0-5.39-.09-9.26l.17.17L540.9,46c-.22.22.3-.3.25-.24h0V49c0,1.1,0,2.18,0,3.24,0,2.13,0,4.2,0,6.18l-.23-.23,20.69.11,6,.06,1.62,0,.58,0a3.2,3.2,0,0,1-.52,0l-1.58,0-6,.06-20.85.11h-.23v-.23c0-2,0-4.05,0-6.18V45.75h0c-.06.05.46-.47.24-.25l28.92.07H570v.18c0,3.92-.07,7.11-.1,9.37,0,1,0,1.89,0,2.51A6.55,6.55,0,0,1,569.82,58.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.34,
    y: 273.9,
    width: 46.25,
    height: 12.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.59,
    y: 248.78,
    width: 46.25,
    height: 12.24,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.28,273.9a2,2,0,0,1,0-.22c0-.17,0-.37,0-.63,0-.57,0-1.38,0-2.41,0-2.11,0-5.15-.08-9l.14.14L38,261.9l.23-.23h0v6.19c0,2,0,4.05,0,6l-.23-.23,33,.11,9.73.06,2.63,0,.69,0h.24s-.07,0-.21,0h-.66l-2.58,0-9.68.07-33.12.1H37.8V261.69h0l.24-.24,46.24.09h.15v.15c0,3.86-.07,6.93-.08,9.06,0,1,0,1.81,0,2.37,0,.25,0,.45,0,.61S84.29,273.91,84.28,273.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 645.24,
    y: 360.55,
    width: 46.25,
    height: 12.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.49,
    y: 335.43,
    width: 46.25,
    height: 12.24,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.19,360.55a.89.89,0,0,1,0-.22c0-.16,0-.37,0-.63,0-.57,0-1.37,0-2.4,0-2.12,0-5.15-.08-9l.15.14-46.25.1c.1-.11-.24.23.23-.24h0v12.21l-.23-.23,33,.11,9.72.06,2.63,0,.69,0h.25l-.22,0h-.66l-2.58,0-9.67.07-33.12.11h-.23v-.24c0-2,0-4,0-6v-6.2h0l.24-.24,46.25.1h.14v.14c0,3.86-.06,6.93-.08,9.06,0,1,0,1.81,0,2.38,0,.25,0,.44,0,.6A1.14,1.14,0,0,1,705.19,360.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.33,
    y: 344.36,
    width: 49.62,
    height: 13.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485,371.31a2.17,2.17,0,0,1,0-.24l0-.67,0-2.58c0-2.27,0-5.53-.08-9.64l.15.16-49.61.1c.11-.12-.26.25.25-.26h0v3.35c0,1.11,0,2.22,0,3.31v6.46l-.25-.25,35.36.12,10.44.07,2.82,0,.74,0H485s-.07,0-.23,0H484l-2.77,0-10.38.07-35.54.11h-.24v-.25q0-3.17,0-6.46v-6.66h0l.26-.25L485,358h.16v.15c0,4.15-.07,7.44-.09,9.73,0,1.09,0,1.94,0,2.55,0,.26,0,.47,0,.64S485,371.32,485,371.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.34,
    y: 398.1,
    width: 49.62,
    height: 13.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637,424.64s0-.09,0-.24l0-.68c0-.61,0-1.48,0-2.58,0-2.27,0-5.52-.08-9.63l.15.15-49.62.1.25-.25h0v13.11l-.25-.25,35.36.11,10.44.07,2.82,0,.74,0a.76.76,0,0,1,.26,0h-.23l-.71,0-2.77,0-10.38.07-35.53.11h-.25V411.53h0l.25-.25,49.62.09h.16v.16c0,4.14-.06,7.43-.08,9.72,0,1.09,0,1.94,0,2.55,0,.27,0,.48,0,.65A.85.85,0,0,1,637,424.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.48,
    y: 205.31,
    width: 49.62,
    height: 13.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.12,232.27a1.35,1.35,0,0,1,0-.24c0-.18,0-.4,0-.68,0-.61,0-1.48,0-2.58,0-2.27,0-5.52-.09-9.63l.16.15-49.62.1.25-.25h0v6.65c0,2.19,0,4.34,0,6.46l-.24-.25,35.36.11,10.43.07,2.83,0,.73,0a.91.91,0,0,1,.27,0h-.23l-.71,0-2.77,0L567,232.4l-35.53.11h-.25v-.24c0-2.12,0-4.27,0-6.46v-6.65h0c.51-.51.14-.14.26-.25l49.62.09h.15v.16c0,4.14-.07,7.43-.09,9.72q0,1.63,0,2.55c0,.27,0,.48,0,.65A1.66,1.66,0,0,1,581.12,232.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.74,456.42c-1.38-1.18-4.44-4.91-2.08-9.25.87-1.59,2.71-2.38,4.37-3.08a17.57,17.57,0,0,0,4.79-2.48c2.6-2.21,3.32-5.88,5-8.83,2-3.38,5.68-5.92,9.58-5.74,4.47.2,8.2,3.85,9.89,8s1.75,8.79,1.78,13.28c0,2.49-.09,5.29-1.91,7s-4.22,1.57-6.5,1.5l-24.43-.75",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.46,389.24H494.22l11.57,69a7.71,7.71,0,0,0,5.48,6.14l.23.06c.19.05.37.11.57.15a8,8,0,0,0,1.31.15v.06l.31,0h28.63a8.22,8.22,0,0,0,1.58-.16,7.74,7.74,0,0,0,6.5-6.75L556,410.32l.25-1.89h0l2.21-18.83Zm-12.12,44h-6.59l.66-20h7.64Zm2.35-20H555l-2.35,20H547Zm-18.83,42.23-.41-17.4H539l-.58,17.4Zm-10.27-17.4h9.23l.4,17.4h-8.28Zm.71,17.4h-7.73c-.73-4.7-1.69-10.8-2.73-17.4H519Zm-1.08-22.2-1.56-20h10.58l.47,20Zm10.12,0-.46-20h10.89l-.66,20Zm-.57-24.83-.42-18.55h12.2l-.62,18.55Zm-.64,0H517.29l-1.44-18.55h11.86Zm-11.48,0H505.17c-.4-2.56-.79-5-1.13-7.17-1.2-7.5-1.65-10.32-1.9-11.38h13.07Zm.37,4.8,1.56,20h-9.49c-.32-2-.64-4.09-1-6.15-.74-4.72-1.49-9.45-2.18-13.88Zm-8.58,20h-6.2l-3.35-20h6.4C506.27,419.42,507.35,426.31,508.44,433.26Zm.76,4.8,2.72,17.4H506l-2.92-17.4ZM539,455.46l.58-17.4h6.34l-1.49,17.4Zm1.56-47,.62-18.55h8.86l-1.59,18.55Zm-39-18.55c.26,1.34,1.43,8.64,3,18.55h-6.45L495,389.88Zm48.52,65.58h-5l1.49-17.4h5.52Zm5.52-47H549.1l1.59-18.55h7Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704,464.62c0,.14-147.33.26-329,.26s-329-.12-329-.26,147.29-.26,329-.26S704,464.48,704,464.62Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.75,133.58,572.9,127a24.48,24.48,0,1,0-5.86,6.51h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.75,133.58a3.24,3.24,0,0,1-.48,0h-1.46l-5.78,0h-.22l.14-.18h0l.15.16a24.5,24.5,0,0,1-34.49-4.37,24.54,24.54,0,0,1,.89-31.13,24.5,24.5,0,0,1,9.77-6.86,25.23,25.23,0,0,1,11.29-1.53,24.63,24.63,0,0,1,22.06,26A24.26,24.26,0,0,1,573,127l0-.09,1.32,5,.33,1.26c.07.29.11.43.1.42s-.06-.16-.14-.45-.22-.73-.39-1.28c-.33-1.13-.81-2.77-1.43-4.87v0l0,0a24.28,24.28,0,0,0-18.28-36.74,24.61,24.61,0,0,0-11.06,1.51,24.14,24.14,0,0,0-14.87,27.87,24.23,24.23,0,0,0,11.6,15.65,24.54,24.54,0,0,0,15.92,2.87A24.48,24.48,0,0,0,567,133.37l.68-.52-.53.68h0l-.08-.18,5.7.15,1.49,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.08,104l.75,11.72a1.9,1.9,0,0,0,1.78,1.77h0a1.9,1.9,0,0,0,2-1.69l1.3-11.77a1.48,1.48,0,0,0-1.5-1.65l-2.86,0A1.49,1.49,0,0,0,550.08,104Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.71,124.05a2.86,2.86,0,1,1-1.81-3.61A2.85,2.85,0,0,1,555.71,124.05Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.35,116.91l1.86-6.63a24.43,24.43,0,1,1,5.85,6.51h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.35,116.91l.52,0,1.49,0,5.7-.15-.08.18h0l-.53-.68.69.52A24.38,24.38,0,0,0,188,121.39a24.54,24.54,0,0,0,15.92-2.87,24.15,24.15,0,0,0,6.3-36.8A23.88,23.88,0,0,0,200.63,75a24.57,24.57,0,0,0-11-1.51,24.26,24.26,0,0,0-18.28,36.73l0,0v0c-.62,2.1-1.1,3.74-1.43,4.87-.16.55-.29,1-.38,1.28s-.15.45-.15.45,0-.14.1-.42l.33-1.26c.31-1.16.75-2.83,1.33-5v.09A24.15,24.15,0,0,1,167.48,99a24.65,24.65,0,0,1,22.05-26,25.23,25.23,0,0,1,11.29,1.53A24.58,24.58,0,1,1,177,116.88l.16-.16h0l.14.18h-.22l-5.78,0h-1.46A3.47,3.47,0,0,1,169.35,116.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.42,98a2.48,2.48,0,1,0,2.48-2.48A2.48,2.48,0,0,0,199.42,98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.51,98A2.48,2.48,0,1,0,192,95.49,2.48,2.48,0,0,0,189.51,98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.62,96.73a2.48,2.48,0,1,0,3.38-.91A2.48,2.48,0,0,0,179.62,96.73Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580.12,247.34s-15.16.4-16.79,2-15.51,51.4-15.34,55.89S569.45,314,571.48,312s13.87-57.44,13.87-57.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.22,247.45a3.29,3.29,0,0,1-.19.64l-.66,1.79-2.43,6.6c-2,5.57-4.71,13.33-7.5,21.94s-5.25,16.39-7.07,22.1l-2.21,6.68c-.25.75-.46,1.35-.62,1.81a3,3,0,0,1-.26.62,4.08,4.08,0,0,1,.16-.65c.13-.47.31-1.08.53-1.84.5-1.65,1.2-3.93,2-6.73,1.75-5.67,4.14-13.52,6.93-22.15s5.53-16.36,7.65-21.91c1.06-2.77,1.95-5,2.59-6.54l.75-1.76A4.39,4.39,0,0,1,577.22,247.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.68,283.88a20,20,0,0,1-5.7-1.32,19.63,19.63,0,0,1-5.3-2.47c.06-.14,2.44.94,5.47,2S564.71,283.73,564.68,283.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.91,183.34,569.18,213l-23-16.13-10.92,3.61s27.25,30.94,31.34,33.3c4.25,2.45,9.8,5.11,14.64-.94,4.41-5.52,21-39.7,21-39.7Z",
    style: {
      fill: "#c17560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.55,165.44a1.73,1.73,0,0,1,1.55-.68l10.18,1a3.22,3.22,0,0,1,2.22,1.32l22.16,31.6-1.58,1-11.22,0-23.61-33.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.87,169.39a.72.72,0,0,1-1-1,.62.62,0,0,1,.85.15A.63.63,0,0,1,526.87,169.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.25,165.85a12.67,12.67,0,0,0,2,.31l5.4.65,3.73.41a2.11,2.11,0,0,1,1.59.87l1.27,1.82,5.66,8.09c4,5.73,7.71,10.9,10.39,14.63l3.21,4.39a11,11,0,0,0,1.25,1.56,14.81,14.81,0,0,0-1.05-1.7l-3-4.5c-2.6-3.79-6.22-9-10.25-14.73l-5.7-8.07-1.29-1.81a2.64,2.64,0,0,0-2-1.05l-3.74-.34-5.43-.45A11.47,11.47,0,0,0,519.25,165.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.89,177s.9-.19,1.48,2.26,2.42,9.48,2.42,9.48l4.64-2.68,6,.57s1.33,1.14.4,1.82-4.64,1.48-4.64,1.48L538.52,194l7.79-4.1s2.66.6,2,2.24-5.88,6.87-5.88,6.87l4-.44,4.62-3s1.45,0,.95,1.27-5.24,5.87-5.24,5.87l-5.85,3.1s-3.26-.14-3.6-1.09a11,11,0,0,1-.48-2.3s-1.74-.4-2.09-1.22a5.24,5.24,0,0,1-.19-2.16s-2.69.57-3.07-.93a16.89,16.89,0,0,1,0-5.64c.23-1.17-1.57-11.91-1.48-12.24S529.17,176.36,530.89,177Z",
    style: {
      fill: "#c17560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.8,205.36a3.41,3.41,0,0,0,1.57.43,10.56,10.56,0,0,0,3.92-.32,10.3,10.3,0,0,0,3.52-1.73c.8-.62,1.18-1.12,1.13-1.17s-1.94,1.55-4.82,2.31S537.83,205.17,537.8,205.36Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.33,202.54c.1.14,1.13-.45,2.23-1.42s1.81-1.91,1.69-2-1,.62-2.09,1.57S538.23,202.4,538.33,202.54Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535,197.52c.1.13,1.13-.44,2.15-1.46s1.61-2,1.47-2.13-.91.73-1.9,1.7S534.92,197.38,535,197.52Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.59,193.5c.16.06.72-1.07,1.62-2.32s1.79-2.16,1.67-2.29-1.22.6-2.16,1.93A4.58,4.58,0,0,0,531.59,193.5Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.44,222.57a18.51,18.51,0,0,0-6.28-9.61,12.21,12.21,0,0,1,6.28,9.61Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.37,257.23,583.47,260c-4.37,12.88-5,26.81-3.46,40.32S585.28,327,589.47,340c25.47,2.21,51.09,4.41,76.57,2.35,2.09-.17,4.4-.48,5.78-2.06,1.13-1.31,1.33-3.16,1.45-4.88C675.17,308.32,668.38,281,655.37,257.23Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.66,279.24c.22.77-6.45,19.09-5,32.42S581,377.08,581,377.08l6.67,74.8h23.51s4.74-97.29,6.05-109.4S622,305.59,622,305.59s12.12,52.83,14.37,60c3.65,11.6,13,50,15.95,58.15s7.87,28.17,7.87,28.17l21.32-5.15s-5.92-42.42-9.12-56.22c-3.58-15.46-3.49-24.94-2.51-40.69s.66-46.34-6.23-62.7l-3-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.41,92.79a7.14,7.14,0,0,1,3.64-3.2,13.07,13.07,0,0,1,10.94,0,11.59,11.59,0,0,1,6.42,8.75,10.4,10.4,0,0,1-4.39,9.79,12.35,12.35,0,0,1,5.72,1.62,2.22,2.22,0,0,1,1.19,1.26c.22.91-.74,1.76-1.68,1.81a4,4,0,0,1-2-.57,2.85,2.85,0,0,1,1.46,1.71c.29,1.33-1.11,2.54-2.47,2.6a7.08,7.08,0,0,1-3.8-1.36L636.28,97.26A3.69,3.69,0,0,1,635.41,92.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.69,115.29s-5.06,18.89-5.49,32.25l-.15,4.45s11.15,9.26,20.5,9.83l7.83-19.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.19,126.87c-2.13-9.21-3-19.93-10.61-25.94-5.68-4.45-12.16-5.7-19.37-5.39-3.56.14-7.57,1.78-10.66,3.54-4.25,2.4-6,7.27-8.09,11.7-4.11,8.86-3.59,20.87-.81,24.21l37.06,19.57c7.39-3.86,12-5.39,13.21-15.25A35.93,35.93,0,0,0,654.19,126.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.19,108.25l-23.32-6.88c-7.51-1.09-12.89,8-13.67,15.55-.86,8.39-1.58,18.67-.83,25,1.51,12.7,11.12,14.69,11.12,14.69s0,.19-.06,3.94l0,7.72c-.1,2.46.33,3.29,1.83,5.23,3.44,4.46,9.71,5.06,17.1,2.32,4.28-1.58,7.26-4.77,7.59-9.12l0-51.39C643,113,645.47,108.59,643.19,108.25Z",
    style: {
      fill: "#c17560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.81,128.66a1.64,1.64,0,0,0,1.5,1.7A1.54,1.54,0,0,0,612,129a1.61,1.61,0,0,0-1.49-1.69A1.55,1.55,0,0,0,608.81,128.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.75,124.53c.19.22,1.45-.64,3.19-.57s3,1,3.18.79-.09-.48-.63-.91A4.49,4.49,0,0,0,611,123a4.3,4.3,0,0,0-2.55.72C607.85,124.06,607.65,124.43,607.75,124.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.7,129.41a1.62,1.62,0,0,0,1.5,1.69,1.54,1.54,0,0,0,1.72-1.39,1.62,1.62,0,0,0-1.49-1.7A1.56,1.56,0,0,0,623.7,129.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.88,124.74c.19.21,1.45-.64,3.19-.57s3,1,3.18.79-.09-.48-.63-.91a4.42,4.42,0,0,0-2.54-.89,4.23,4.23,0,0,0-2.55.71C625,124.26,624.78,124.64,624.88,124.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.09,136a11.37,11.37,0,0,0-2.8-.63c-.45-.06-.86-.16-.93-.47a2.34,2.34,0,0,1,.35-1.31c.46-1.06.94-2.17,1.45-3.33,2-4.75,3.49-8.66,3.3-8.74s-2,3.7-4,8.45l-1.39,3.36a2.58,2.58,0,0,0-.3,1.74,1.1,1.1,0,0,0,.71.67,2.87,2.87,0,0,0,.75.14A12.24,12.24,0,0,0,618.09,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.44,156.59a32.08,32.08,0,0,0,17.07-3.85s-4.52,8.67-17.1,7Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.22,118.36c.12.49,1.88.43,3.89.88s3.6,1.15,3.91.76c.14-.19-.1-.66-.72-1.19a6.66,6.66,0,0,0-2.83-1.3,6.54,6.54,0,0,0-3.12.06C624.58,117.8,624.17,118.13,624.22,118.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.89,119.84c.4.34,1.67-.25,3.26-.5s3-.17,3.24-.62c.1-.22-.17-.58-.81-.87a5.11,5.11,0,0,0-2.75-.26,4.87,4.87,0,0,0-2.48,1.17C607.84,119.24,607.71,119.67,607.89,119.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.79,100l-.06.28,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.21,162.94c-6.3-.37-6.6-6.89-6.22-10.2a77.88,77.88,0,0,1,2.13-10.91c1.49-5.45-.56-11.24-1.31-16.88a13.39,13.39,0,0,1-8.21-4.73c-2.53-3-4.06-6.61-5.55-10.2a17.08,17.08,0,0,0,3.44,9.81,4.62,4.62,0,0,1-3.94-1.28,10.35,10.35,0,0,1-2.31-3.59A28,28,0,0,1,619,104.87a36.1,36.1,0,0,0,1.65,14.74,6.41,6.41,0,0,0-2.75.1,3,3,0,0,1-2.61-.55,3.25,3.25,0,0,1-.71-1.68,37.74,37.74,0,0,1-.42-12.85,39.54,39.54,0,0,0-2.9,7.12,13.79,13.79,0,0,0,0,7.59,1.11,1.11,0,0,1-1.57,0,2.62,2.62,0,0,1-.68-1.58,19.4,19.4,0,0,1,.41-6.39c-1.26,2.23-1.68,4.83-2.38,7.3s-1.81,5-4,6.41a33.54,33.54,0,0,1,.31-9.68,29.44,29.44,0,0,1,2.84-7.69,22.93,22.93,0,0,1,5.12-7.12c3.72-3.26,5.27-1.86,7.65-.61l.28.11a1.11,1.11,0,0,1,0-.17l.1-.51a35.68,35.68,0,0,1,18.76.88c4.48,1.46,4.89,11.1,6,6.52.66-2.77,4.25-.24,4.3-.16,5.28,9.52,10.87,24.63,11.13,48.5h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.36,106.26c-.75.35-2.89-2.92-6.7-5.49s-7.57-3.5-7.51-4.33c0-.38,1.11-.68,2.85-.5a14.58,14.58,0,0,1,10.83,7.48C648.61,105,648.71,106.09,648.36,106.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.79,139.6c-.43-.75,0-1.68-.75-1.43a21,21,0,0,0-4.85,2.21c-.28.31.16.87.26,1.12s0,.13.2.31a5.76,5.76,0,0,0,2.29,1.55,2.48,2.48,0,0,0,2.65-.86A3.09,3.09,0,0,0,623.79,139.6Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.26,143.08a3,3,0,0,0,1.89-.05,2,2,0,0,0,1.38-1.3,4.13,4.13,0,0,0-.11-2.47,6.48,6.48,0,0,0-.43-1l.33.11a35.26,35.26,0,0,1-5.39,2.08,35.53,35.53,0,0,1,5.18-2.55l.21-.1.12.2a6.69,6.69,0,0,1,.47,1.05,4.43,4.43,0,0,1,.08,2.78,2.39,2.39,0,0,1-1.73,1.52,2.7,2.7,0,0,1-1.53,0C620.38,143.27,620.24,143.1,620.26,143.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.2,433.69l.42,25.58-5.5,20.33a2.64,2.64,0,0,0,2,3.26h0a2.64,2.64,0,0,0,2.31-.66c3.93-3.72,18.31-17.48,18.17-19.35-.16-2.17,1.34-27,1.34-27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.14,482.86l20.49-21.74v1.09a3.92,3.92,0,0,1-1,2.55c-1.63,1.9-6.27,7-17.14,17.44a2.65,2.65,0,0,1-2.39.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.43,452.84a1.58,1.58,0,0,0-.44,2.07,1.52,1.52,0,0,0,2,.46,1.68,1.68,0,0,0,.47-2.19,1.59,1.59,0,0,0-2.19-.25",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M594.06,471.72a7.81,7.81,0,0,0-2.23-2,8.13,8.13,0,0,0-2.94-.58c0-.06.3-.26.9-.34a4.18,4.18,0,0,1,4,2C594.09,471.32,594.12,471.7,594.06,471.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.22,475.13c-.13.11-.94-.72-2.26-1.11a20.93,20.93,0,0,0-2.5-.34,2.9,2.9,0,0,1,2.66-.2C591.63,473.93,592.35,475.06,592.22,475.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.48,467.35a26.87,26.87,0,0,0-3.37-2c-2-.81-3.79-.73-3.79-.91a7.17,7.17,0,0,1,7.16,2.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598,459.56c-.07.15-1.48-.45-3.32-.52s-3.3.35-3.35.19a5.11,5.11,0,0,1,3.38-.75A5,5,0,0,1,598,459.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.07,452.05a12.76,12.76,0,0,0-3.44-.64,12.55,12.55,0,0,0-3.4.83c0-.05.24-.37.83-.71a5.72,5.72,0,0,1,5.14-.14C597.81,451.69,598.1,452,598.07,452.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.58,433.83l3.63,25.32L661.31,480a2.62,2.62,0,0,0,2.41,3h0a2.61,2.61,0,0,0,2.21-.95c3.43-4.18,16-19.63,15.6-21.47-.43-2.13-2.06-27-2.06-27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.72,483l17.6-24.14.13,1.08a3.93,3.93,0,0,1-.62,2.65c-1.39,2.09-5.34,7.78-14.82,19.46a2.67,2.67,0,0,1-2.29.95Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M675.13,451.29a1.58,1.58,0,0,0-.19,2.11,1.54,1.54,0,0,0,2.09.2,1.68,1.68,0,0,0,.18-2.24,1.58,1.58,0,0,0-2.19,0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M668.2,471.19a8.11,8.11,0,0,0-2.47-1.7,7.74,7.74,0,0,0-3-.21c0-.06.27-.3.85-.45a4.05,4.05,0,0,1,2.33.13,4,4,0,0,1,1.89,1.35C668.17,470.8,668.26,471.17,668.2,471.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.8,474.81a24.32,24.32,0,0,0-2.39-.82,20,20,0,0,0-2.51,0,2.87,2.87,0,0,1,2.61-.53C666.06,473.69,666.92,474.73,666.8,474.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671,466.43a26,26,0,0,0-3.59-1.52,27.26,27.26,0,0,0-3.87-.42,7.16,7.16,0,0,1,7.46,1.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.58,458.64c-.05.16-1.52-.26-3.36-.11s-3.23.77-3.3.62a6.48,6.48,0,0,1,6.66-.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.7,451.18a8.34,8.34,0,0,0-6.76,1.05c-.05-.05.19-.4.74-.81a5.68,5.68,0,0,1,5.07-.79C669.4,450.85,669.73,451.12,669.7,451.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.52,168.41c1.21,0,12.49,3.15,15.34,11.33,2.32,6.68,8.88,35.79,8.88,35.79h-27s-5.65-16.4-4.85-25.48S653.52,168.41,653.52,168.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.33,250l7.38-41.5-3.17-40.19-10.61-1.65c-10.23,4.65-19.4,5.48-26.81,0l-9.85,1.22s-10.31.47-18.88,11c-3.18,3.9-16.29,24.52-16.29,24.52l15.11,9.36c.44,9.64,1.49,25.64,1.49,25.64l-13.64,52.81s27.22,8.81,43.08,8.81c22.29,0,47.59-12.26,47.59-12.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.59,185.27a7.57,7.57,0,0,1-.75,1.23c-.26.38-.57.85-.9,1.42s-.74,1.18-1.12,1.91a49.58,49.58,0,0,0-2.54,5.19,53.45,53.45,0,0,0-2.24,6.69,54.64,54.64,0,0,0-1.26,6.95,51.42,51.42,0,0,0-.27,5.77c0,.82,0,1.57.07,2.22s.06,1.22.1,1.67a8.19,8.19,0,0,1,.07,1.44,7.07,7.07,0,0,1-.27-1.41c-.07-.46-.15-1-.19-1.68s-.14-1.4-.15-2.23a42.54,42.54,0,0,1,.17-5.82,50.32,50.32,0,0,1,1.22-7,51.65,51.65,0,0,1,2.31-6.75,43.42,43.42,0,0,1,2.66-5.19c.4-.72.84-1.33,1.2-1.88a15.53,15.53,0,0,1,1-1.38A8.09,8.09,0,0,1,595.59,185.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.59,263a10.59,10.59,0,0,1-2.11-1.64,34.85,34.85,0,0,1-4.36-4.75,34.06,34.06,0,0,1-3.43-5.47,10.3,10.3,0,0,1-1-2.47,18.74,18.74,0,0,1,1.34,2.29,48,48,0,0,0,3.52,5.33,48.52,48.52,0,0,0,4.21,4.8A16.84,16.84,0,0,1,610.59,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.61,249.67a6.17,6.17,0,0,1-.3,2,29.26,29.26,0,0,1-3.77,8.71,6,6,0,0,1-1.22,1.56c-.13-.08,1.53-2.58,3-6S633.46,249.63,633.61,249.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.52,222.69s-.26,0-.71,0a11.71,11.71,0,0,1-1.88-.42,16.16,16.16,0,0,1-9.54-8,10.82,10.82,0,0,1-.73-1.78,1.85,1.85,0,0,1-.16-.69c.09,0,.42.91,1.22,2.3a17.81,17.81,0,0,0,9.33,7.84C622.55,222.43,623.54,222.6,623.52,222.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.38,213.14a5.24,5.24,0,0,1-.42-1.09c-.24-.71-.55-1.75-.91-3-.72-2.58-1.58-6.19-2.28-10.23s-1.08-7.73-1.26-10.41c-.09-1.33-.14-2.42-.15-3.17a4.74,4.74,0,0,1,0-1.17,6,6,0,0,1,.17,1.16c.08.85.19,1.91.31,3.15.27,2.66.72,6.33,1.41,10.35s1.49,7.63,2.12,10.23c.29,1.21.54,2.24.75,3.08A4.35,4.35,0,0,1,653.38,213.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.35,251,617,263.42v8.1l-38.25-2.31a24.36,24.36,0,0,1,0-12.23C580.53,250.53,585.35,251,585.35,251Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617,263.42,649.71,251s10.63,7.71,8.62,19.9l-41.32.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.91,
    cy: 266.12,
    rx: 6.58,
    ry: 6.89,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.52,308.23c-.27-3.2-2.89-5.51-4.67-8.12-2.18-3.19-3.18-7.09-3.87-10.95s-1.11-7.79-2.3-11.51-3.26-7.31-6.48-9.32l-.1.6a42.74,42.74,0,0,0-1.39,36.34,20.39,20.39,0,0,0,5.24,7.65,9.58,9.58,0,0,0,8.49,2.25A7,7,0,0,0,637.52,308.23Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M637.52,308.23c-.27-3.2-2.89-5.51-4.67-8.12-2.18-3.19-3.18-7.09-3.87-10.95s-1.11-7.79-2.3-11.51-3.26-7.31-6.48-9.32l-.1.6a42.74,42.74,0,0,0-1.39,36.34,20.39,20.39,0,0,0,5.24,7.65,9.58,9.58,0,0,0,8.49,2.25A7,7,0,0,0,637.52,308.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M624.2,304.74c-.66-2.82-2.17-5.33-3.27-8-3.53-8.59-2.59-18.37-1.58-27.66l-6.68-.17c-6.48,9.22-7.93,21.32-7.46,32.75.1,2.44.3,7.07,1.22,9.31s2.21,5.17,4.49,5.69l-.13,2.26,6.06-.08.09-1.91c1.23-.85,4.19-3.24,5.34-4.2C624.45,310.93,624.86,307.56,624.2,304.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.66,261.94a19.74,19.74,0,0,0-2.57-1.69,6.38,6.38,0,0,0-3.17-.66,5.65,5.65,0,0,0-3.51,1.68,7.84,7.84,0,0,0-2,3.43A11.64,11.64,0,0,0,611,268c0,1.91.32,3.08.23,3.1a2.34,2.34,0,0,1-.27-.81,12.11,12.11,0,0,1-.32-2.28,11,11,0,0,1,.34-3.42,8.08,8.08,0,0,1,2.12-3.67,6,6,0,0,1,3.84-1.79,6.43,6.43,0,0,1,3.36.81,8.36,8.36,0,0,1,1.87,1.37C622.51,261.67,622.68,261.92,622.66,261.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.52,265.67c0,.09-.54.13-1.33.43a8.36,8.36,0,0,0-2.77,1.78,22.09,22.09,0,0,0-2.22,2.53c-.54.68-.89,1.1-1,1.06s.19-.53.65-1.27a13.8,13.8,0,0,1,2.17-2.7,7,7,0,0,1,3-1.75A2.32,2.32,0,0,1,618.52,265.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.87,269.43a23.4,23.4,0,0,1-3.63-4,22.61,22.61,0,0,1-3-4.52,37.89,37.89,0,0,1,3.42,4.2A37.4,37.4,0,0,1,620.87,269.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.07,271a11.75,11.75,0,0,0-.53-9.18s.43.36.84,1.15a8.74,8.74,0,0,1,.39,6.78A3.06,3.06,0,0,1,623.07,271Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.72,167.43l-67.6,79.91,3.06,4,70.36-83A4.39,4.39,0,0,0,647.72,167.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.53,215.87c.56.61,9.62,18.57,8.55,23.48s-6.62,8-8.55,8-14.94-31.47-14.94-31.47l11.79-5.6Z",
    style: {
      fill: "#c17560"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "660.54 241.01 639.51 241.01 636.07 237.98 668.62 195.04 687.87 196.89 690.62 199.41 660.54 241.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "690.06 203.36 663.3 240.18 646.85 239.55 644.24 237.04 674.24 199.51 688.41 201.28 690.06 203.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.99 237.71 674.7 200.38 688 201.77 689.14 203.14 675.55 201.76 646.54 239.08 644.99 237.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "636.82 238.65 669.68 196.02 687.5 197.65 689.34 199.27 671.24 197.92 638.57 240.18 636.82 238.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.63,237.05l-4.25-.92s-1.08-6.52-2.5-7.33-13.68-.8-14.92.73-.71,2.15-.71,2.15-3.37-.77-3.91,3.22c0,0-3.56.52-2.13,3.53,0,0-3.55,1.84-1.42,4a4.65,4.65,0,0,0,2.31,4.92,10.65,10.65,0,0,0,6.39,1.07l20-1.07Z",
    style: {
      fill: "#c17560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.78,233.46a4.52,4.52,0,0,0-1.7,0,16.44,16.44,0,0,1-4.25.68,3.83,3.83,0,0,1-2.28-.92,2.44,2.44,0,0,1-.8-1.87,1.87,1.87,0,0,1,.48-1.27c.23-.24.4-.29.42-.27a2.38,2.38,0,0,0-.53,1.54,2.12,2.12,0,0,0,.75,1.51,3.58,3.58,0,0,0,2,.76,24.49,24.49,0,0,0,4.15-.52C656.18,232.93,656.85,233.41,656.78,233.46Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.26,240.36a18.23,18.23,0,0,1-6-5.48,26.07,26.07,0,0,1,3,2.7A26.4,26.4,0,0,1,650.26,240.36Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.22,245.17A14.07,14.07,0,0,1,642,237.9c.14-.08,1.15,1.84,2.88,3.84S648.31,245,648.22,245.17Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645,247a6,6,0,0,1-2.61-2,6.14,6.14,0,0,1-1.68-2.8c.14-.07.89,1.16,2.06,2.46A31.83,31.83,0,0,1,645,247Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.39,235.65a8.52,8.52,0,0,1-2.29,6.58c-.13-.09.74-1.41,1.36-3.22S666.24,235.64,666.39,235.65Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.25,236.67c-.06.14-1.58-.48-3.56-.69s-3.61,0-3.64-.11a6.51,6.51,0,0,1,3.69-.4A6.42,6.42,0,0,1,673.25,236.67Z",
    style: {
      fill: "#7c4236"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.71,287.65c.12.07-.39,1.05-1.46,1.82s-2.16,1-2.19.83.89-.52,1.88-1.25S482.59,287.56,482.71,287.65Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.92,433.22l-.43,25.58,5.5,20.33a2.63,2.63,0,0,1-2,3.26h0a2.64,2.64,0,0,1-2.31-.66c-3.93-3.72-18.31-17.48-18.17-19.35.16-2.17-1.34-27-1.34-27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,482.39l-20.49-21.74v1.09a3.94,3.94,0,0,0,1,2.55c1.63,1.9,6.27,7,17.14,17.44a2.65,2.65,0,0,0,2.39.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.68,452.37a1.58,1.58,0,0,1,.44,2.07,1.52,1.52,0,0,1-2,.46,1.67,1.67,0,0,1-.46-2.2,1.58,1.58,0,0,1,2.18-.24",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M460.05,471.25c.15.07.71-1.28,2.23-2a8.16,8.16,0,0,1,2.94-.58c0-.06-.3-.26-.9-.34a4.16,4.16,0,0,0-2.29.42,4.08,4.08,0,0,0-1.71,1.58C460,470.85,460,471.23,460.05,471.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.89,474.66c.13.11.94-.73,2.26-1.11a21.2,21.2,0,0,1,2.5-.34A2.9,2.9,0,0,0,464,473C462.49,473.46,461.76,474.59,461.89,474.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.63,466.88a25.5,25.5,0,0,1,3.37-2,27,27,0,0,1,3.79-.91,7.17,7.17,0,0,0-7.16,2.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.11,459.09c.07.15,1.48-.45,3.32-.52s3.3.35,3.35.19a5.12,5.12,0,0,0-3.38-.76A5.05,5.05,0,0,0,456.11,459.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,451.58a8.33,8.33,0,0,1,6.84.19s-.24-.37-.83-.71a5.57,5.57,0,0,0-2.55-.68,5.47,5.47,0,0,0-2.58.54C456.31,451.22,456,451.52,456,451.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.35,431.85l.38,21.14s-21.37,7.48-21.68,11.4l41,.75.77-33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.44,451.45a1.68,1.68,0,0,1,1.13,1.93,1.61,1.61,0,0,1-1.91,1.13,1.77,1.77,0,0,1-1.18-2.05,1.68,1.68,0,0,1,2.11-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.07,465.14l-.05-3.33-39.31.53s-1.84.76-1.66,2.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.06,452.77c0,.2,1,.31,2,1s1.48,1.52,1.67,1.44-.09-1.24-1.28-2S403,452.59,403.06,452.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.73,454.47c-.05.2.81.55,1.48,1.41s.84,1.76,1,1.76.35-1.14-.5-2.19S398.74,454.28,398.73,454.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.19,459.58c.18,0,.48-.95,0-2.06s-1.43-1.56-1.52-1.39.49.76.88,1.67S396,459.56,396.19,459.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.51,447.94c.08.19,1-.07,2.14,0s2,.47,2.11.3-.72-.9-2.06-1S403.42,447.79,403.51,447.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.69,122.85c1.29-.75,2.91-.72,4.21-1.44a5.45,5.45,0,0,0,2.46-3.57,15,15,0,0,0,.17-4.44l9.27,17.39a15.53,15.53,0,0,1-4.34,3.91,5.86,5.86,0,0,1-5.62.21c-1.69-1-2.5-3.46-1.35-5a4.6,4.6,0,0,1-6-1.13A4.26,4.26,0,0,1,431.69,122.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.77,85c2.53,2.68,2.62,4.9,2.53,6.06,0,.34-.16.76-.5.8a.76.76,0,0,1-.48-.13L467.08,87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.64,118.23a80.06,80.06,0,0,1-3.63-13.3,28,28,0,0,1,.93-13.63c.24-.66,2.26-5.07,2.95-5,.5,0-.73,4.15-.47,4.58a23.66,23.66,0,0,1,2.82,13.77,61.7,61.7,0,0,1-2.6,13.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.86,143.11,440,100.68c-.51-11.53,5.78-21.44,17.32-21.63l1.07,0a20.64,20.64,0,0,1,19.76,19.81c.38,10,.68,21,.39,26.39-.6,11.06-11.74,12.32-11.74,12.32s0,11.26,0,14.51l-16.68-.93-4-.38Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.78,137.62a26.74,26.74,0,0,1-14.23-4.86s3.12,8.46,14.2,7.93Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.4,109.36a1.57,1.57,0,0,1-1.59,1.53,1.5,1.5,0,0,1-1.56-1.49,1.57,1.57,0,0,1,1.58-1.53A1.5,1.5,0,0,1,474.4,109.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.57,103.7c-.21.2-1.37-.74-3.07-.81s-3,.74-3.16.52.13-.46.69-.83a4.34,4.34,0,0,1,2.54-.67,4.16,4.16,0,0,1,2.43.9C475.51,103.23,475.67,103.61,475.57,103.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.68,108.82a1.58,1.58,0,0,1-1.59,1.53,1.5,1.5,0,0,1-1.57-1.49,1.58,1.58,0,0,1,1.59-1.53A1.52,1.52,0,0,1,459.68,108.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.88,103.4c-.2.19-1.36-.74-3.06-.81s-3,.73-3.16.52.12-.46.69-.84a4.34,4.34,0,0,1,2.54-.66,4.15,4.15,0,0,1,2.42.89C458.82,102.93,459,103.31,458.88,103.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.44,116.72a10.69,10.69,0,0,1,2.78-.38c.43,0,.85-.1.93-.39a2.16,2.16,0,0,0-.23-1.3c-.37-1.07-.75-2.19-1.15-3.36-1.58-4.79-2.71-8.71-2.52-8.77s1.64,3.76,3.22,8.54c.38,1.18.75,2.31,1.09,3.38a2.46,2.46,0,0,1,.16,1.71,1.09,1.09,0,0,1-.74.61,3,3,0,0,1-.75.07A11.58,11.58,0,0,1,464.44,116.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.66,98.1c-.25.42-1.88-.1-3.89-.23s-3.7.12-3.88-.34c-.08-.22.27-.59,1-.92a6.78,6.78,0,0,1,5.91.44C459.47,97.47,459.77,97.9,459.66,98.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.22,99.12c-.37.37-1.74-.07-3.41-.13s-3.08.18-3.39-.24c-.14-.2.09-.58.72-.93a5.43,5.43,0,0,1,2.78-.55,5.19,5.19,0,0,1,2.7.85C476.19,98.53,476.38,98.93,476.22,99.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.54,108.91c-.18-.09-7.51-2.57-7.58,5s7.54,6.09,7.56,5.87S440.54,108.91,440.54,108.91Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.23,116.9s-.13.09-.35.19a1.33,1.33,0,0,1-1,0c-.8-.3-1.46-1.58-1.48-2.94a4.4,4.4,0,0,1,.39-1.89,1.5,1.5,0,0,1,1-1,.66.66,0,0,1,.77.37c.1.21.05.36.09.37s.17-.12.11-.44a.83.83,0,0,0-.29-.47,1,1,0,0,0-.73-.2,1.82,1.82,0,0,0-1.39,1.16,4.45,4.45,0,0,0-.48,2.1c0,1.53.8,3,1.89,3.29a1.42,1.42,0,0,0,1.21-.18C438.22,117.08,438.26,116.91,438.23,116.9Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.24,86.36c1.22-.68-2.45-4.65-5.46-6-4.55-2.07-11.51-3.35-15.71-2.17-5.05,1.43-9.25,3.94-11.8,8.54a29.85,29.85,0,0,0-3.36,15.21,9.08,9.08,0,0,0,1.06,4.63c1.06,1.67,2.57,2.5,3,5a4.16,4.16,0,0,0,.78,2.31c1.39,1.48,3.08.1,3.86-1.29,1.67-3,1.86-6.51,2-9.91a22,22,0,0,0-.47-7.2c-.37-1.27-1-2.46-1.26-3.74a4.54,4.54,0,0,1,.54-3.78,4.44,4.44,0,0,1,.62-.63,7.92,7.92,0,0,1,7.84-1.48c4.26,1.52,11.54,3.78,13.45,2.33,2.74-2.08,3.39-3.44,3.39-3.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.09,117.77c.26,0,.27,1.72,1.77,3s3.34,1,3.36,1.27-.41.34-1.2.37a4.34,4.34,0,0,1-2.8-1,3.76,3.76,0,0,1-1.37-2.47C458.78,118.19,459,117.76,459.09,117.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.28,108.59c-.14-.13-.36-.16-.49-.29-8.94-8.53-1.82-16.71-1.7-19.24.16-3.5-4,.92-4.55-3.69-.71-6.1,5.81-8.7,13.82-11.32,3.36-1.09,11.59-1.42,18.81.11,6.44,1.35,10.73,5.94,13.17,9.46A5.45,5.45,0,0,1,476.2,85c1.12,2.1.61,3,.61,3s-14.22-7.41-26.16,2.29-9.8,18.09-12.95,18.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,79.25a5.13,5.13,0,0,1-.63.27,7.21,7.21,0,0,0-.74.3c-.28.12-.61.25-1,.43a21.38,21.38,0,0,0-5,3.4,23.41,23.41,0,0,0-2.3,2.44,22.76,22.76,0,0,0-1.56,2.24c-.22.33-.38.65-.53.91a7.14,7.14,0,0,0-.37.71c-.2.39-.31.6-.32.6a3.19,3.19,0,0,1,.24-.64c.09-.2.19-.45.34-.72s.3-.6.5-.94A20.65,20.65,0,0,1,435.18,86a21.61,21.61,0,0,1,2.3-2.48,22.33,22.33,0,0,1,2.69-2,18.88,18.88,0,0,1,2.43-1.32c.35-.17.68-.29,1-.41s.55-.2.76-.27A4.46,4.46,0,0,1,445,79.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.72,83.82l-.13,0-.38-.15q-.51-.23-1.47-.6c-.65-.23-1.44-.52-2.38-.78a24.77,24.77,0,0,0-3.23-.73,25.84,25.84,0,0,0-8.58.09,26.48,26.48,0,0,0-9.77,3.79,25.25,25.25,0,0,0-4.25,3.42,27.51,27.51,0,0,0-3.21,3.93,37.53,37.53,0,0,0-3.85,7.7c-.86,2.31-1.4,4.23-1.77,5.55-.17.66-.31,1.17-.41,1.53l-.11.4a.42.42,0,0,1,0,.13s0,0,0-.13l.09-.41c.08-.35.2-.87.37-1.54.34-1.33.87-3.26,1.7-5.58a37.19,37.19,0,0,1,3.83-7.76,26.76,26.76,0,0,1,3.23-4,25.15,25.15,0,0,1,4.28-3.45,26.57,26.57,0,0,1,4.91-2.47,28,28,0,0,1,4.94-1.34,25.81,25.81,0,0,1,8.64,0,23.94,23.94,0,0,1,3.24.76c.94.27,1.73.58,2.38.82s1.13.48,1.45.64l.38.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.16,104.85a4.19,4.19,0,0,1-3.72-1.46,11.69,11.69,0,0,0,1.75,1A11,11,0,0,0,440.16,104.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.15,98.14a2.06,2.06,0,0,1-.77-.18,5.81,5.81,0,0,1-3-2.37,1.74,1.74,0,0,1-.34-.72,10.26,10.26,0,0,0,1.76,2A11,11,0,0,0,444.15,98.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,89.87a20.37,20.37,0,0,0-1.41-2.09A19.49,19.49,0,0,0,447.79,86a5.38,5.38,0,0,1,2,1.59A5.56,5.56,0,0,1,451,89.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.9,86.44a22.14,22.14,0,0,0-.69-2.2c-.5-1.17-1.18-2-1.12-2a4.94,4.94,0,0,1,1.32,1.93A4.84,4.84,0,0,1,457.9,86.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.23,85.79a5,5,0,0,0-1.16-4.29,1.53,1.53,0,0,1,.52.46,4,4,0,0,1,.77,1.49,4.13,4.13,0,0,1,.09,1.68A1.72,1.72,0,0,1,468.23,85.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.47,87.29a13.05,13.05,0,0,0,.2-1.78,13.41,13.41,0,0,0-.25-1.77,3.76,3.76,0,0,1,.05,3.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.71,273.82c0,1-6.81,91.18-6.29,99.65s0,75,0,75h22.79s4.87-80.79,5.55-84.86,4.74-17.28,4.74-17.28L448.18,287s-1.21,48.15,0,55.61-1.49,22.71-1.49,27.12-3.86,80.63-3.86,80.63l21,.08s1.23-5.75,2.06-9.42c.52-2.32,5.12-43.39,5.43-45.34.8-5.06,1.87-19.38,3.2-25.62,1-4.48,8.38-53.33,8.73-54.23.54-1.4,4.15-33.56,4.15-33.56V269.83l-77.62-9.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.2,140.37a28.08,28.08,0,0,0,15.41,5.18c8.54.14,12.67-1.77,12.67-1.77l1.77,6.44,8.18,70.57-7.09,47-42.25-2.73,10-54.78-.61-63.25Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,150.22c0,.08,1.38,23.93,1.31,25.4-.9,19.73-8.81,129.6-8.81,129.6l27-1,.83-7.77-1.9-67.68,3.61-43.09,1.9-31.85L472.2,146l-3.49-6.36-2-1.23Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491,153.83s8.51,3.36,12,23.73c1.9,11.23,3.93,37.12,3.93,37.12s2.72,22.91,0,26.89l-2.73,1-17.16-5-.71-5.23,2.15-6.49v-4.11l-5.67-20.23V169.11Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491,167.89a2.49,2.49,0,0,1,0,.57c0,.43,0,1,0,1.62,0,1.42,0,3.47-.12,6-.19,5-.81,12-1.76,19.68s-1.86,14.58-2.4,19.61c-.27,2.51-.48,4.54-.61,5.95-.06.66-.12,1.19-.16,1.62a2.33,2.33,0,0,1-.1.56,2.28,2.28,0,0,1,0-.57c0-.43,0-1,.07-1.63.07-1.41.22-3.45.45-6,.44-5,1.3-12,2.25-19.63s1.61-14.6,1.9-19.64c.15-2.52.25-4.57.28-6,0-.66.05-1.2.07-1.62A2.09,2.09,0,0,1,491,167.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.14 250.29 450.68 284.89 499.91 287.19 501.61 253.58 456.36 250.31 453.56 250.3 452.14 250.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.56 250.3 452.4 283.02 455.78 283.02 456.36 250.21 453.56 250.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.31,251.38c.14,0,.08,7.62-.13,17s-.5,17-.64,17-.09-7.62.12-17S458.16,251.37,458.31,251.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.6,252.42a6,6,0,0,1-1.32,0l-3.59-.18c-3-.17-7.21-.44-11.83-.78l-11.82-.9-3.59-.15a6,6,0,0,1-1.31-.13,6.3,6.3,0,0,1,1.32-.08h3.59c3,.12,7.22.43,11.84.75s8.8.67,11.82.93l3.58.35A7.4,7.4,0,0,1,485.6,252.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.78,279.07s6.11-5.95,9.13-8,8.14-2.71,8.14-2.71l8.85,8.84s-4.76,12.39-5.72,13.13a7.84,7.84,0,0,1-2.77.84,6.17,6.17,0,0,1-3.37-.39l-1-.4s-6.79-.42-7.11-1.75c0,0-3.33.5-4.55-.71a5.53,5.53,0,0,1-1.3-2.49l6.89-2.73,1.75-4s-4.76,2.71-6.64,3.18S464.44,280.25,465.78,279.07Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.08,236.83l-5,31.56,8.85,8.84s4.5-10.8,6.24-16.48c1.85-6,6.76-20.07,6.76-20.07S494.88,235.06,488.08,236.83Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.28,285.7c.06-.05.23.52-.3,1.1a3,3,0,0,1-1.08.66c-.42.17-.88.34-1.38.5a9.84,9.84,0,0,1-3.69.72,23.91,23.91,0,0,1,3.53-1.21,9.55,9.55,0,0,0,2.36-.94C478.21,286.14,478.2,285.69,478.28,285.7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.37,146a18.13,18.13,0,0,1,.81,2.55c.45,1.61,1.06,3.89,1.76,6.55l.18.7-.58-.44a16.06,16.06,0,0,1-2.94-3,16.41,16.41,0,0,1-1.27-2l.47,0c-1,3-1.76,5.75-2.25,7.71a31.63,31.63,0,0,1-.83,3.13,2.94,2.94,0,0,1,.07-.86c.09-.56.22-1.36.43-2.35a69.66,69.66,0,0,1,2.1-7.79l.18-.56.28.52a19.12,19.12,0,0,0,1.23,1.9,16.38,16.38,0,0,0,2.84,2.91l-.39.25c-.66-2.66-1.21-5-1.59-6.6A15.6,15.6,0,0,1,472.37,146Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.57,219.7s-1.13,19.8-.51,23.9,14.55,10,14.55,10l10.9-2.41s2.16-20.06,2.28-20.67,0-14.93,0-14.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.86,148.6s-4,1.93-6.93,10.79c-1.68,5-21.92,40.17-22,47.55-.12,9.41,16.72,18.1,16.72,18.1l14.52-20.18-6.28-3.75,9.26-8.1Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.22,140.42s-21.76,6.69-23.36,8.18,4.5,35.66,4.5,35.66v47.8l-11.43,51.8s23.19,22.45,33.47,20.2c0,0,7.11-41.7,9-58.16s2.24-44.32,1.87-55.54-1.87-34.79-1.87-35.35c0-.41-1.28-13.81-1.4-19.83H439.2L436,139.49Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.25,143.68S428.11,158,428.61,167s2.86,34.66,2.86,34.66h7.82s-2.23-35.16-2.73-43.11-1.37-19.38-1.37-19.38S420.08,141.41,419.25,143.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.57,196.56a2.51,2.51,0,0,0-1.09-1.2,2.45,2.45,0,0,0-1.84.25c-1.35.58-2.68,1.18-4,1.81l3.14,5.05a15.56,15.56,0,0,1,3-2.57,2.55,2.55,0,0,0,1.3-1.74A2.87,2.87,0,0,0,448.57,196.56Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M439.75,210.19a1.85,1.85,0,0,0-.94-1c-.76-.27-1.5.42-2,1.06-5.66,7.27-8.5,16.91-15.9,22.4-4.25,3.15-9.59,4.56-13.89,7.65l-.16,2.3c7.51.36,14.49-3.64,20.66-7.94,4.09-2.85,8.14-6,10.79-10.21S442,214.65,439.75,210.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M405.86,234.57s12.79-5.08,20.27-10.6,10-19.88,10-19.88l4.13-2.47s-5.09,24.11-12,29.69-22.4,15-22.4,15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,202.57s.15-.22.5-.54a10.89,10.89,0,0,1,1.62-1.18,14.14,14.14,0,0,1,6.29-2,14,14,0,0,1,6.5,1.15,10.51,10.51,0,0,1,1.76,1c.39.26.59.44.57.46s-.92-.49-2.47-1.08a14.79,14.79,0,0,0-12.46.82C386.85,202,386.05,202.64,386,202.57Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,203.75l20.29,4.09s6.35-10.75,7.05-11.21,11.44.33,11.44.33,4.1,3.64,4.21,6-2.45,4.9-2.45,4.9.23,2-2.57,4c0,0,.35,2.68-1.52,3.62,0,0,.47,2.69-1.05,3.5s-3.74-.81-3.74-.81l-3.3.11s-2.08,3.74-3.36,4.21-34.24,1.05-34.24,1.05-4.67-2.45-2.92-8.88A15.5,15.5,0,0,1,403,203.75Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.35,216.4a17.48,17.48,0,0,1-.26-4.28,17.48,17.48,0,0,1,.26-4.28,35.36,35.36,0,0,1,0,8.56Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,215.74c-.12.1-1.07-1.06-2.64-1.94s-3-1.14-3-1.29a5,5,0,0,1,3.28.83A5,5,0,0,1,439,215.74Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.17,207.28a11,11,0,0,1,5.81,4.33c-.12.1-1.25-1.06-2.85-2.24S435.11,207.42,435.17,207.28Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.75,202.47a9,9,0,0,1,7.09,4.64,32.54,32.54,0,0,0-3.25-2.77A31.21,31.21,0,0,0,436.75,202.47Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.86,158.09a9.94,9.94,0,0,1,.3,1.52c.16,1.07.38,2.47.64,4.15.51,3.51,1.19,8.36,1.84,13.74s1.16,10.25,1.44,13.79c.14,1.77.23,3.2.27,4.19a9.67,9.67,0,0,1,0,1.55,8.16,8.16,0,0,1-.21-1.53c-.12-1.08-.26-2.49-.44-4.18-.37-3.52-.92-8.39-1.58-13.76s-1.25-10.14-1.7-13.75c-.19-1.69-.35-3.1-.47-4.18A8,8,0,0,1,406.86,158.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.58,201.66a4.76,4.76,0,0,1,1.48-1.68,8.57,8.57,0,0,1,5.05-1.9,8.71,8.71,0,0,1,5.18,1.54,4.43,4.43,0,0,1,1.58,1.59c-.06.06-.63-.58-1.78-1.28a8.82,8.82,0,0,0-9.81.34C390.18,201,389.65,201.72,389.58,201.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.28,157.31a10.22,10.22,0,0,1-.85-2,39.51,39.51,0,0,1-1.54-5.48l.41.07-3.47,6.23-.41.74-.07-.84c0-.3-.06-.61-.08-.93a106.77,106.77,0,0,1-.36-11.25c0-1.44.09-2.6.15-3.4a5.79,5.79,0,0,1,.14-1.25,5.92,5.92,0,0,1,.06,1.25c0,.91,0,2.05,0,3.41,0,2.87.14,6.83.5,11.19,0,.32.06.64.08.93l-.48-.1c1.28-2.26,2.49-4.37,3.53-6.2l.3-.53.12.6a50.32,50.32,0,0,0,1.35,5.48A18.5,18.5,0,0,1,442.28,157.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.13,224a5.28,5.28,0,0,1-.92.76c-.62.46-1.53,1.1-2.67,1.85a59.94,59.94,0,0,1-9.45,5.1,17.23,17.23,0,0,1-5.76,1.44,12.68,12.68,0,0,1-4.81-.7,15.86,15.86,0,0,1-3-1.36,5.6,5.6,0,0,1-1-.66c.05-.11,1.49.84,4.08,1.67a13.31,13.31,0,0,0,4.67.58,17.72,17.72,0,0,0,5.6-1.45,73.14,73.14,0,0,0,9.44-4.93l2.75-1.71A5.85,5.85,0,0,1,426.13,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.57,231.05a5.51,5.51,0,0,1-.92.79c-.6.48-1.5,1.16-2.62,2-2.24,1.64-5.39,3.83-9,6.09s-6.92,4.16-9.36,5.47c-1.22.66-2.22,1.17-2.92,1.51a5.42,5.42,0,0,1-1.11.48,5.5,5.5,0,0,1,1-.66l2.84-1.65c2.39-1.39,5.69-3.34,9.27-5.59s6.75-4.39,9-5.95c1.08-.73,2-1.35,2.72-1.84A4.85,4.85,0,0,1,428.57,231.05Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244,188s-21.84,8.76-22.87,16.23-.52,53.3,6.95,62.82,13.39,11.08,20.34,9.79a56.75,56.75,0,0,0,13-4.23l9.19-36.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.07,260.87a5.47,5.47,0,0,1-1.31,0c-.85-.06-2.07-.11-3.57-.12a53.9,53.9,0,0,0-11.68,1.18,54.88,54.88,0,0,0-11.14,3.71c-1.36.63-2.46,1.18-3.2,1.58a6.19,6.19,0,0,1-1.19.57,6.53,6.53,0,0,1,1.09-.74,35.79,35.79,0,0,1,3.14-1.74,48.15,48.15,0,0,1,23-4.93,33.6,33.6,0,0,1,3.57.29A7.23,7.23,0,0,1,261.07,260.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,263.45a4,4,0,0,1-.22-.66c-.12-.43-.3-1.07-.49-1.9-.41-1.66-.92-4.08-1.39-7.1-1-6-1.62-14.45-2.23-23.74s-1.14-17.64-1.54-23.78c-.17-3-.31-5.45-.41-7.21,0-.81-.06-1.46-.09-2a3.19,3.19,0,0,1,0-.68,3.35,3.35,0,0,1,.1.68l.18,1.95c.14,1.76.34,4.21.58,7.2.43,6.14,1,14.52,1.69,23.78s1.17,17.69,2.07,23.72c.43,3,.88,5.44,1.23,7.11.16.79.29,1.43.4,1.92A4.06,4.06,0,0,1,236,263.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,235.68a24.08,24.08,0,0,1-5.46,1.91,25.16,25.16,0,0,1-5.68,1.1,44.55,44.55,0,0,1,5.54-1.6A45.5,45.5,0,0,1,233,235.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,189.7a2.45,2.45,0,0,1,.06.61c0,.46,0,1.05.07,1.77.05,1.53.13,3.75.25,6.49.25,5.48.75,13,1.71,21.35s2.2,15.79,3.22,21.17c.5,2.7.93,4.88,1.24,6.38.14.71.25,1.28.33,1.73a3.07,3.07,0,0,1,.09.62,2.91,2.91,0,0,1-.19-.59c-.11-.45-.25-1-.43-1.72-.37-1.49-.85-3.66-1.4-6.34-1.11-5.38-2.41-12.86-3.38-21.19s-1.41-15.91-1.56-21.4c-.07-2.74-.1-5-.08-6.5,0-.72,0-1.3,0-1.76A2.69,2.69,0,0,1,239.34,189.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.79,151a5.79,5.79,0,0,0-3.22-3.07,38.05,38.05,0,0,0-12.72-3.29,106.84,106.84,0,0,0-27.33.32,40.47,40.47,0,0,0-11.69,3.09,9.05,9.05,0,0,0-3.24,2.27,4,4,0,0,0-.89,3.71,2.63,2.63,0,0,0,3.11,1.78l50,2a13.21,13.21,0,0,0,4.44-2.29A4.48,4.48,0,0,0,327.79,151Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.71,122.59a2.53,2.53,0,0,1-3.29-1.44,5.67,5.67,0,0,1,.12-4,16.81,16.81,0,0,0,1-3.9,5.74,5.74,0,0,0-3.86-5.64,5.37,5.37,0,0,0,.38-7.73,21.22,21.22,0,0,0-3.44-2.21,12.19,12.19,0,0,1-1.81-1.48,7.31,7.31,0,0,0,3.12.1,5,5,0,0,0,3.66-3.21,4.58,4.58,0,0,0-1.1-4.69,4.21,4.21,0,0,0-4.72-.7c-1.48.78-2.29,2.39-3,3.9-.22.47-.45.93-.67,1.4-2.08-2.76-4-5.61-7.25-6.58-2.91-.88-6,.11-9.08-.11-2.21-.16-4.33-1-6.53-1.2s-4.71.23-6,2c-.76,1-1,2.42-1.78,3.46-1.59,2.16-5,2.46-6.34,4.8-1.07,1.91-.25,4.31-.7,6.45-.5,2.32-2.41,4-4,5.8s-2.93,4.23-2.05,6.43c.77,1.94,3,3,3.77,4.94.54,1.43.15,3,.12,4.53s.58,3.33,2.07,3.68l16.89,4.46c5.81,2.36,11.82,4.77,18.09,4.76s13-3,15.47-8.79a3.65,3.65,0,0,1-2.43-1.09A6.06,6.06,0,0,0,323.71,122.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.86,127.88a77.92,77.92,0,0,0,3.41-13.06,27.36,27.36,0,0,0-1.07-13.33c-.24-.64-2.27-4.93-2.95-4.87-.49,0,.76,4.06.52,4.48a23.17,23.17,0,0,0-2.61,13.51,61.42,61.42,0,0,0,2.7,13.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.11,89.73l-1,0A20.21,20.21,0,0,0,273,109.4c-.26,9.79-.62,19.19-.28,24.41.72,10.82,11.83,11.95,11.83,11.95v5.58c.48,5.7,7.86,6.72,10.65,6.48,9.67,0,14.7-4.24,14.7-4.24l.46-42.88C310.67,99.41,304.41,89.78,293.11,89.73Z",
    style: {
      fill: "#b5675e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,145.74a26.19,26.19,0,0,0,13.87-4.93s-3,8.06-13.87,7.67Z",
    style: {
      fill: "#c17560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,118.28a1.54,1.54,0,0,0,1.57,1.48,1.47,1.47,0,0,0,1.52-1.48,1.54,1.54,0,0,0-1.57-1.48A1.48,1.48,0,0,0,277,118.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.51,113.77c.2.19,1.32-.74,3-.82s2.93.68,3.1.47-.14-.45-.69-.81a4.2,4.2,0,0,0-2.49-.62,4.12,4.12,0,0,0-2.37.9C275.56,113.31,275.41,113.69,275.51,113.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.44,118.32A1.56,1.56,0,0,0,293,119.8a1.49,1.49,0,0,0,1.52-1.48,1.55,1.55,0,0,0-1.58-1.48A1.48,1.48,0,0,0,291.44,118.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.84,113.57c.2.19,1.33-.74,3-.82s2.93.68,3.1.47-.13-.45-.69-.81a4.2,4.2,0,0,0-2.49-.62,4.15,4.15,0,0,0-2.37.9C291.9,113.11,291.74,113.49,291.84,113.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.56,126.67a11.83,11.83,0,0,0-2.73-.34c-.43,0-.83-.08-.92-.37a2.11,2.11,0,0,1,.21-1.27l1.09-3.3c1.49-4.7,2.55-8.56,2.36-8.62s-1.55,3.71-3.05,8.4c-.36,1.16-.7,2.27-1,3.32a2.5,2.5,0,0,0-.13,1.68,1.07,1.07,0,0,0,.73.59,3.3,3.3,0,0,0,.73.06A10.35,10.35,0,0,0,286.56,126.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.51,127.56c-.27,0-.17,1.81-1.65,3.17s-3.41,1.27-3.41,1.52.45.33,1.26.31a4.43,4.43,0,0,0,2.85-1.17,3.91,3.91,0,0,0,1.27-2.65C291.86,128,291.64,127.55,291.51,127.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.57,106.82c.19.44,1.84.14,3.8.27s3.57.57,3.81.16c.1-.2-.19-.62-.85-1a6.46,6.46,0,0,0-2.86-.83,6.37,6.37,0,0,0-2.94.5C291.83,106.23,291.49,106.61,291.57,106.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.9,108.21c.31.36,1.44-.1,2.81-.19s2.56.12,2.81-.29c.11-.2-.1-.57-.63-.9a4.1,4.1,0,0,0-4.53.39C275.9,107.63,275.76,108,275.9,108.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.85,118.76c.18-.09,7.32-2.6,7.48,4.82s-7.31,6-7.33,5.83S309.85,118.76,309.85,118.76Z",
    style: {
      fill: "#b5675e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.2,126.55s.14.09.36.18a1.21,1.21,0,0,0,1,0,3.19,3.19,0,0,0,1.42-2.9,4.36,4.36,0,0,0-.4-1.84,1.49,1.49,0,0,0-1-1,.66.66,0,0,0-.75.37c-.1.21-.05.36-.08.37s-.17-.12-.11-.43a.82.82,0,0,1,.28-.47,1,1,0,0,1,.71-.2,1.81,1.81,0,0,1,1.37,1.12,4.42,4.42,0,0,1,.5,2.06c0,1.49-.75,2.91-1.82,3.24a1.36,1.36,0,0,1-1.18-.17C312.22,126.73,312.18,126.56,312.2,126.55Z",
    style: {
      fill: "#894943"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.59,97.06c-1.21-.65,2.35-4.58,5.28-6,4.43-2.08,11.22-3.41,15.34-2.3,5,1.34,9.11,3.75,11.65,8.22a29.3,29.3,0,0,1,3.47,14.85,9,9,0,0,1-1,4.55c-1,1.65-3,2.71-2.87,5a3.15,3.15,0,0,1-.74,2.27c-1.34,1.46-3,.13-3.8-1.22-1.67-2.89-1.89-6.35-2.08-9.68a21.63,21.63,0,0,1,.38-7.05c.35-1.24.91-2.42,1.19-3.68a4.45,4.45,0,0,0-.57-3.69,3.86,3.86,0,0,0-.61-.6,7.73,7.73,0,0,0-7.69-1.37c-4.16,1.53-11.26,3.83-13.14,2.44a11.53,11.53,0,0,1-3.36-3.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.81,87.8a16.26,16.26,0,0,0-12.51.85,8.47,8.47,0,0,0-4.41,5c-.59,2.21.38,4.9,2.5,5.73l.15.09c3.18,1,5.23.57,8.37-.56,2.64-1,5-2.62,7.63-3.56a15,15,0,0,1,8.81-.37A24.57,24.57,0,0,0,297.81,87.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.91,95.13c-.06.06-.66-.65-1.86-1.48a10.47,10.47,0,0,0-2.25-1.21,6.94,6.94,0,0,0-3-.5,10.07,10.07,0,0,0-5.17,2.13c-1.14.91-1.68,1.67-1.75,1.62s.08-.23.33-.57a8.08,8.08,0,0,1,1.2-1.32,9.58,9.58,0,0,1,5.35-2.36A7.14,7.14,0,0,1,308,92a10,10,0,0,1,2.29,1.34A5.67,5.67,0,0,1,311.91,95.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.65,97.76a6.34,6.34,0,0,1-.56,2.12,15.44,15.44,0,0,1-6.92,7.8,6.49,6.49,0,0,1-2,.81,23.16,23.16,0,0,0,5.81-4.44A23.2,23.2,0,0,0,312.65,97.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.67,99a2.69,2.69,0,0,1,0,.85,13.14,13.14,0,0,1-.32,2.27,15.52,15.52,0,0,1-9.64,11.06,13.65,13.65,0,0,1-2.21.63,2.33,2.33,0,0,1-.84.08c0-.08,1.16-.29,2.92-1a16.62,16.62,0,0,0,6-4.31A17,17,0,0,0,315,102C315.54,100.16,315.58,99,315.67,99Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.32,87.13c0,.08-.77.26-2,.74a16.27,16.27,0,0,0-4.3,2.54,16.08,16.08,0,0,0-3.31,3.73c-.7,1.08-1,1.81-1.1,1.78a5.68,5.68,0,0,1,.8-2,14,14,0,0,1,7.79-6.41A5.63,5.63,0,0,1,289.32,87.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,88.06a7,7,0,0,1-1.88,4.12,7.11,7.11,0,0,1-3.73,2.57,21.23,21.23,0,0,0,3.36-2.89A19.87,19.87,0,0,0,318,88.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,288.59s-2.8,74.82-2.8,79.5c0,5.4-.37,19.94-.26,26.42S256,434.9,256,434.9l.87,12h21.63s7-78.28,7.48-84.77,9.34-68.31,9.83-66.81,10,61.83,10.4,68.31,0,83.27,0,83.27h24.18s4.55-48.74,6-71.29c1.32-20.9,6.14-64.34,6.14-64.34v-32l-48.17-4.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,431.63l.56,21.18s21.29,7.84,21.54,11.77l-41.11.08-.24-33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.84,451.06a1.67,1.67,0,0,0-1.16,1.91,1.62,1.62,0,0,0,1.89,1.17,1.78,1.78,0,0,0,1.22-2,1.67,1.67,0,0,0-2.1-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,464.66l.1-3.33,39.38,1.17s1.83.79,1.63,2.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.22,452.6c0,.2-1,.29-2,.94s-1.51,1.49-1.69,1.41.11-1.23,1.32-2S330.26,452.42,330.22,452.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.54,454.37c0,.2-.83.54-1.51,1.39s-.87,1.75-1.07,1.74-.33-1.14.53-2.18S334.53,454.18,334.54,454.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,459.53c-.19,0-.47-1,.05-2.06s1.45-1.54,1.53-1.37-.49.75-.9,1.66S337.2,459.51,337,459.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.85,447.75c-.09.19-1-.09-2.14,0s-2,.44-2.12.27.74-.89,2.08-1S330,447.6,329.85,447.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,429.57l-.42,25.63-6.17,20.18a2.64,2.64,0,0,0,1.92,3.33h0a2.61,2.61,0,0,0,2.33-.59c4.05-3.6,18.91-16.9,18.83-18.78-.08-2.17,2.23-27,2.23-27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.28,478.71l21.23-21.1,0,1.09a3.93,3.93,0,0,1-1,2.52c-1.7,1.85-6.51,6.85-17.74,16.9a2.63,2.63,0,0,1-2.41.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.58,449.14a1.59,1.59,0,0,0-.52,2.06,1.52,1.52,0,0,0,2,.53,1.68,1.68,0,0,0,.54-2.18,1.59,1.59,0,0,0-2.18-.32",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.57,467.74c-.15.07-.67-1.3-2.17-2.08a8.16,8.16,0,0,0-2.93-.68c0-.06.31-.25.92-.31a4.17,4.17,0,0,1,2.28.5,4,4,0,0,1,1.66,1.64C261.61,467.34,261.63,467.72,261.57,467.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.61,471.1c-.13.11-.92-.76-2.23-1.19a21,21,0,0,0-2.49-.42,2.94,2.94,0,0,1,2.68-.11C259.06,469.88,259.75,471,259.61,471.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.14,463.48a27.59,27.59,0,0,0-3.32-2.07,25.54,25.54,0,0,0-3.76-1,7.16,7.16,0,0,1,7.08,3.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.91,455.7c-.07.15-1.46-.5-3.3-.64s-3.32.25-3.37.09a6.5,6.5,0,0,1,6.67.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.22,448.18a12.44,12.44,0,0,0-3.42-.76,13.13,13.13,0,0,0-3.43.72c0-.05.25-.36.86-.68a5.63,5.63,0,0,1,2.57-.6,5.71,5.71,0,0,1,2.57.62C266,447.81,266.27,448.12,266.22,448.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.29,153.28l-22.1,4.78,4.33,74.51L255.4,289c1.36,5.45,29.84,5.77,45.78,5.32,15.12-.44,40-6.73,41.76-9.55s-7.58-63.52-7.58-63.52v-63l-24.48-5.58S297,161,283.29,153.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,280s41.49,2.26,51.92,1.54c16.48-1.15,35.18-7.15,35.18-7.15V268.6s2.24-3.08,2.19-9.05a70.35,70.35,0,0,0-.81-9.73c-2.46-14.18-5.48-41.7-5.48-41.7l-3.7-49.81-10.85-3.53L311.41,150l-13.86,12.38s-9.36-9.49-13.78-12l-23,7.91L258.29,227s-1.72,13.61-2.89,22.82c-.62,4.91-3.14,8.71-3.14,12.59,0,4.92,4.92,9.43,4.92,9.43Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.72,240.84c8.95,5.77,20.12,6.52,30.76,7.1a118,118,0,0,0,18.42.05,39.56,39.56,0,0,0,17.4-5.58c2.83-1.82,5.37-4.13,8.43-5.5,2.06-.92,4.32-1.4,6.26-2.56s3.55-3.3,3.13-5.52a5.23,5.23,0,0,0-4-3.74,15.28,15.28,0,0,0-5.72,0c-2.77.33-5.73.75-7.78,2.64-1.76,1.62-2.51,4-3.77,6.07-2.54,4.09-7.12,6.57-11.83,7.61s-9.58.81-14.39.57l-35.25-1.73"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M360.78,201s-8.54-29.67-14.52-35.65-10.9-7-10.9-7l2.9,43.91,2.16,4.45Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.71,177.6c.4-.08.92,7.07,1.47,15.83.27,4.33.53,8.25.72,11.23.1,1.36.18,2.49.25,3.4a8.5,8.5,0,0,1,.05,1.26,5.46,5.46,0,0,1-.26-1.23c-.12-.8-.26-2-.41-3.39-.3-2.87-.6-6.84-.87-11.23s-.47-8.25-.64-11.24c-.08-1.35-.14-2.49-.19-3.4,0-.35-.05-.65-.07-.92A1.05,1.05,0,0,0,336.71,177.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.53,
    y: 179.66,
    width: 8.15,
    height: 52.78,
    transform: "translate(21.23 -30.24) rotate(5.5)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.49,
    y: 172.77,
    width: 7.61,
    height: 60.69,
    transform: "translate(20.92 -29.55) rotate(5.5)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.6,
    y: 173.92,
    width: 3.27,
    height: 60.69,
    transform: "translate(21.08 -30.78) rotate(5.5)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.8,228.29l2.66-1.36,10.62-8,2.79,2-2.15,4.32s25.56,3.44,25.54,5.16a2.14,2.14,0,0,1-1.83,2h-13.1s.86,3.23-.57,4.06a3.77,3.77,0,0,1-2.15,3.25s.71,1.44-2.08,2.44-18.7,1.68-18.7,1.68Z",
    style: {
      fill: "#b5675e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.6,204.21c-1.74-.35-7-2.06-9.26-1.69a3.9,3.9,0,0,0-2.92,1.79s-4.7,2.05-3.52,5.24a8.54,8.54,0,0,0-1.06,2.57,2.38,2.38,0,0,0,1.32,2.84,4.25,4.25,0,0,0-2,3.12c-.37,2.4,2.19,4,2.19,4-.5,2.72,2.27,3.26,3.62,3.84,2.35,1,18.27.12,18.27.12l.87-16.07S329.93,204.49,328.6,204.21Z",
    style: {
      fill: "#b5675e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.12,225.73a4,4,0,0,1-1,.21l-2.73.39a44.93,44.93,0,0,1-9.1.51,22.71,22.71,0,0,1-5.88-1.16,3.87,3.87,0,0,1-2-1.6,2.39,2.39,0,0,1-.24-2.07l0,.17a15.13,15.13,0,0,1-1.77-1.7,13.32,13.32,0,0,1,2,1.47l.08.06,0,.11a2.15,2.15,0,0,0,.3,1.76,3.57,3.57,0,0,0,1.82,1.37,24.13,24.13,0,0,0,5.75,1.07,55.42,55.42,0,0,0,9-.35c1.16-.11,2.1-.19,2.75-.23A3.57,3.57,0,0,1,334.12,225.73Z",
    style: {
      fill: "#894943"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76,215.21c0,.15-.47.19-1,.1s-.93-.28-.9-.42.46-.18,1-.09S314.78,215.07,314.76,215.21Z",
    style: {
      fill: "#894943"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.68,209.11c0,.15-.37.28-.83.37s-.87.13-.92,0,.3-.39.81-.5S314.68,209,314.68,209.11Z",
    style: {
      fill: "#894943"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.26,199.55s4.38,12.72,5.6,20.93c1.39,9.26-6.41,15.92-15,12.43-3.9-1.58-16.32-6.25-16.32-6.25l1-16.88,5.56.89-2.25-7.55Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.45,231.69a6.37,6.37,0,0,1-1-.3l-2.86-1-10.14-3.56-.16-.06v-.17c.21-4.14.46-9,.72-14.12.06-1.06.12-2.1.17-3.08l0-.35.33.12a29.52,29.52,0,0,0,5.11,1.14l4.85.7a51.84,51.84,0,0,1,8.07,1.65,14.67,14.67,0,0,1,4.94,2.41,5.73,5.73,0,0,1,1.08,1c.23.25.34.38.33.4a2.58,2.58,0,0,1-.4-.34,6.46,6.46,0,0,0-1.12-.93,15.25,15.25,0,0,0-4.93-2.24,56.19,56.19,0,0,0-8-1.52l-4.85-.67a28.35,28.35,0,0,1-5.22-1.15l.35-.23c-.05,1-.11,2-.17,3.09-.28,5.15-.55,10-.79,14.12l-.15-.23,10.08,3.74,2.82,1.08A6.39,6.39,0,0,1,348.45,231.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.88,268.73a5.61,5.61,0,0,1-.86.19l-2.46.46c-2.14.39-5.26.89-9.11,1.42s-8.46,1.06-13.59,1.53-10.78.82-16.72,1-11.6.22-16.75.14-9.78-.29-13.66-.55-7-.5-9.19-.72l-2.49-.27a4.43,4.43,0,0,1-.87-.13s.3,0,.88,0l2.5.16c2.16.17,5.31.37,9.19.56s8.51.36,13.65.44,10.8,0,16.73-.18,11.56-.58,16.69-1,9.72-.93,13.58-1.43,7-.92,9.13-1.25l2.48-.36A4.6,4.6,0,0,1,342.88,268.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.79,158.31c-1.06.35-14.23,4.9-17.24,27.79a166.13,166.13,0,0,0-.73,28.67l23.25-1.94Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.79,158.31s2.46-6.19,8.64-3.21c0,0,.34,19.3.13,29.29-.73,33.72-5,33.88-5,33.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.51,214.11s.63,17.57,6.92,22.91c7.27,6.19,53.4,7.25,53.4,7.25l-1-15.53-37.65-12.11-.47-9.44Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.66,221.65a11.53,11.53,0,0,1,2.64-2.35,15.19,15.19,0,0,1,9.43-2.54h0l37.11,11.73.16.05,0,.18c.09,1.48.2,3.07.31,4.67.24,3.72.48,7.35.72,10.85v.24l-.23,0c-6.59.8-12.78.3-18.32-.14s-10.45-1.13-14.53-1.72-7.34-1.13-9.57-1.53l-2.57-.49-.66-.14-.22-.06.23,0,.67.09,2.58.4c2.24.34,5.5.84,9.59,1.38s9,1.15,14.52,1.6a91,91,0,0,0,18.2.09l-.21.27c-.24-3.51-.48-7.14-.73-10.85-.11-1.61-.21-3.19-.31-4.68l.18.23-37.05-11.9h0a15.14,15.14,0,0,0-9.3,2.35,16.5,16.5,0,0,0-2.07,1.59l-.5.46C252.72,221.61,252.66,221.66,252.66,221.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.11,167.21a3.07,3.07,0,0,1-1,0,21.69,21.69,0,0,1-2.65-.39,31.89,31.89,0,0,1-15.51-8.1,22,22,0,0,1-1.84-1.95,3.49,3.49,0,0,1-.59-.79c.07-.06,1,1,2.67,2.47a36.1,36.1,0,0,0,15.35,8C290.74,167,292.12,167.12,292.11,167.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.17,155.53a4,4,0,0,1-.74.72c-.5.45-1.25,1.05-2.21,1.75a42.3,42.3,0,0,1-8.06,4.59,42.8,42.8,0,0,1-8.86,2.75,27.53,27.53,0,0,1-2.78.41,4.11,4.11,0,0,1-1,.05c0-.09,1.44-.29,3.74-.82a52.28,52.28,0,0,0,8.74-2.86A51.66,51.66,0,0,0,323,157.7C325,156.38,326.11,155.46,326.17,155.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.25,165.11s.11,0,.33,0a4.73,4.73,0,0,1,.92.15,6.09,6.09,0,0,1,2.92,1.82,6,6,0,0,1,1.19,2.1,1.37,1.37,0,0,1-.26,1.45.89.89,0,0,1-.85.2,2.09,2.09,0,0,1-.7-.35,9.23,9.23,0,0,1-3.72-5c-.09-.29-.15-.57-.21-.84l.51-.11a5.92,5.92,0,0,1-1.72,5.63,1.83,1.83,0,0,1-1.38.46,1.24,1.24,0,0,1-1.08-.89,1.88,1.88,0,0,1,.1-1.27,4.56,4.56,0,0,1,.55-1,8.77,8.77,0,0,1,2.27-2.3,3.66,3.66,0,0,1,1-.56,11.34,11.34,0,0,1-.92.72,9.78,9.78,0,0,0-2.1,2.33,2.39,2.39,0,0,0-.54,1.9c.18.69,1.17.77,1.76.19a5.48,5.48,0,0,0,1.51-5.14l.51-.11c.05.25.12.52.2.79a8.85,8.85,0,0,0,3.49,4.73c.37.28.76.43,1,.21a.94.94,0,0,0,.16-1,6,6,0,0,0-1.06-2,6.34,6.34,0,0,0-2.7-1.87C297.7,165.18,297.25,165.15,297.25,165.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,215.85c-.19,0-.8-2.5-1.73-7.09s-2.19-11.22-3.68-19.41l1.94,0c-.87,7.43-1.95,16.31-3.18,26.06l-.71,5.54L299,215.58c-2.37-7.43-4.95-15.55-7.63-24-.32-1-.64-2-.95-3l2.53-.5c.78,9.95,1.51,19.41,2.18,28l.46,6-2.71-5.31c-4-7.89-7.64-15-10.66-21.06l1.75-.47c.17,7.25.62,13.11.95,17.16s.52,6.3.34,6.32-.71-2.17-1.36-6.2a169.89,169.89,0,0,1-1.78-17.21l-.23-4.12,2,3.66c3.22,6,7,13,11.13,20.82l-2.25.65c-.73-8.62-1.54-18.08-2.39-28l-1-11.71,3.54,11.22c.31,1,.63,2,.95,3l7.5,24-2.4.21c1.34-9.73,2.6-18.58,3.68-26l1-6.5,1,6.47c1.25,8.23,2.22,14.91,2.83,19.55S308.2,215.81,308,215.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.1,127.18c-.55-5.37-1.87-10.66-2.15-16.05s.65-11.11,4-15.3,9.79-6.24,14.45-3.52l1.31,4.49c.12,20.89,2.23,41.94,2.35,62.82,0,2.75-2,5.41-3,8s-3.33,4.77-6.07,4.85c-3.59.1-6.26-3.31-7.67-6.61C91.26,153.86,94.41,140.12,93.1,127.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54,98.15a15.13,15.13,0,0,1,2.4-4,5.13,5.13,0,0,1,4.11-1.79,2.13,2.13,0,0,1,1.79,1.07c.3.67-.13,1.63-.86,1.63l-.14.15c-1.49,1.57-3,3.1-4.54,4.61a4.21,4.21,0,0,1-1.3,1,1.45,1.45,0,0,1-1.53-.18C102.82,100,103.16,99,103.54,98.15Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,103.7a27.28,27.28,0,0,1,20.09-12.34c4.76-.5,6.83.32,10.35.94a15.09,15.09,0,0,1,9.09,4.91c2.75,3.24,5.14,6.93,6,11.09a36.43,36.43,0,0,1,.4,12.09,47.86,47.86,0,0,1-5.19,14.78l-7.24,1.55c-6.07.75-12.23,1.5-18.28.64s-12.1-3.54-15.74-8.46C95.36,122.08,96.2,110.72,101,103.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.77,102.75,125,95.6l3.88.1C137.47,95,144.27,104,145,111c.76,7.77,1.37,17.28.65,23.12-1.46,11.74-11.2,13.57-11.2,13.57s.75,6.12,1.16,10l-22.64.38-5.68-51A4.12,4.12,0,0,1,110.77,102.75Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.08,132.91a2.52,2.52,0,0,1,3.74-2,3.34,3.34,0,0,1,1.55,3h0a3.07,3.07,0,0,1-2.07,1.47l-.41.05a2.79,2.79,0,0,1-1.91-.57A2.46,2.46,0,0,1,128.08,132.91Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.7,120.72a1.49,1.49,0,0,1-1.39,1.56,1.44,1.44,0,0,1-1.59-1.3,1.49,1.49,0,0,1,1.39-1.56A1.44,1.44,0,0,1,142.7,120.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.67,115.07c-.18.2-1.35-.6-3-.54s-2.76.9-2.94.71.08-.44.59-.83a4.09,4.09,0,0,1,2.35-.82,4,4,0,0,1,2.36.68C142.57,114.63,142.75,115,142.67,115.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.48,128.56a11.34,11.34,0,0,1,2.6-.56c.41,0,.8-.15.86-.43a2,2,0,0,0-.32-1.21l-1.32-3.09c-1.84-4.41-3.19-8-3-8.11s1.81,3.44,3.65,7.84l1.28,3.12a2.43,2.43,0,0,1,.27,1.6,1.05,1.05,0,0,1-.66.63,2.78,2.78,0,0,1-.7.12A10,10,0,0,1,133.48,128.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.42,147.63A29.8,29.8,0,0,1,118.63,144s4.45,7.95,16.1,6.46Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.78,129.84c.26,0,.32,1.73,1.86,2.92s3.4.93,3.42,1.18c0,.1-.41.35-1.19.4a4.37,4.37,0,0,1-2.85-.89,3.77,3.77,0,0,1-1.45-2.45C128.48,130.27,128.66,129.83,128.78,129.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.62,109.5c-.26.4-1.5.18-2.94.35s-2.62.59-3,.25c-.14-.17,0-.56.49-1a4.55,4.55,0,0,1,4.74-.48C141.51,109,141.73,109.31,141.62,109.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.08,121.6a1.5,1.5,0,0,0,1.55,1.4,1.44,1.44,0,0,0,1.45-1.46,1.5,1.5,0,0,0-1.55-1.4A1.43,1.43,0,0,0,125.08,121.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.91,116.38c.2.18,1.27-.73,2.88-.85s2.84.61,3,.4-.13-.43-.67-.76a4.13,4.13,0,0,0-2.43-.57,4,4,0,0,0-2.27.92C121,115.94,120.81,116.3,120.91,116.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.41,111.16c.35.34,1.56-.13,3-.25s2.77,0,3-.36c.11-.19-.11-.54-.69-.85a4.68,4.68,0,0,0-2.52-.42,4.52,4.52,0,0,0-2.38.91C121.41,110.6,121.26,111,121.41,111.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,126.39c0-.87-1.11-2.89-2-3-2.31-.28-6.43,0-6.27,5.87.21,8,8.16,6.1,8.17,5.87S111.09,129.39,111,126.39Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.64,132.29s-.14.11-.37.22a1.42,1.42,0,0,1-1,.05c-.85-.29-1.59-1.6-1.67-3a4.56,4.56,0,0,1,.33-2,1.61,1.61,0,0,1,1-1.1.72.72,0,0,1,.83.36c.11.22.06.38.1.39s.17-.13.1-.46a.91.91,0,0,0-.33-.49,1,1,0,0,0-.77-.18,2,2,0,0,0-1.42,1.27,4.89,4.89,0,0,0-.42,2.23c.1,1.61,1,3.09,2.12,3.39a1.45,1.45,0,0,0,1.26-.25C108.63,132.49,108.66,132.31,108.64,132.29Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.69,123.45l2.2,1.91c7.94-9.09,23.07-31.43,22.23-30.11A25.48,25.48,0,0,0,120.59,95c-6.37,1.68-18.33,6-17.47,13.61S108.69,123.45,108.69,123.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,122.73a3.11,3.11,0,0,1,.08-.47,8.32,8.32,0,0,1,.43-1.3,11.73,11.73,0,0,1,3-4,21.94,21.94,0,0,1,6.38-3.8c2.57-1.1,5.5-2,8.32-3.55a39.21,39.21,0,0,0,7.43-5.08,41,41,0,0,0,5.09-5.32,42.32,42.32,0,0,0,2.86-4.08c.28-.47.51-.86.7-1.16a2.23,2.23,0,0,1,.26-.39,2.29,2.29,0,0,1-.19.43c-.14.28-.34.69-.63,1.2A37.58,37.58,0,0,1,128,99.37a39.08,39.08,0,0,1-5.07,5.42A38.42,38.42,0,0,1,115.4,110a87,87,0,0,1-8.37,3.54,22.09,22.09,0,0,0-6.33,3.67,11.91,11.91,0,0,0-3,3.87C97.19,122.09,97.07,122.74,97,122.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.44,123.77a4.17,4.17,0,0,1,.15-1.76,8.1,8.1,0,0,1,2.65-4,17.93,17.93,0,0,1,6.37-3.18,39.38,39.38,0,0,0,8-3.34,34.39,34.39,0,0,0,6.92-5.17,35.75,35.75,0,0,0,4.58-5.38,37.28,37.28,0,0,0,2.46-4.1l.57-1.17a2.19,2.19,0,0,1,.23-.4,2,2,0,0,1-.15.43c-.14.32-.3.72-.51,1.21a31.85,31.85,0,0,1-2.36,4.19,34.74,34.74,0,0,1-4.56,5.49,34.35,34.35,0,0,1-7,5.25,38.19,38.19,0,0,1-8.07,3.34,18.2,18.2,0,0,0-6.31,3,8.17,8.17,0,0,0-2.67,3.82A8.26,8.26,0,0,0,99.44,123.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.14,136.84c0-.06-.68-.08-1.88-.29a11.29,11.29,0,0,1-4.65-2.08,16,16,0,0,1-4.68-5.93,27.8,27.8,0,0,1-2.53-9,23.69,23.69,0,0,1-.05-4.83,22.19,22.19,0,0,1,4.47-11.17,37.44,37.44,0,0,1,4.9-5.1s-.16.07-.42.26-.66.46-1.13.87a24.82,24.82,0,0,0-3.65,3.75,22.71,22.71,0,0,0-3.7,6.83,21.52,21.52,0,0,0-.94,9.45,27.38,27.38,0,0,0,2.62,9.14,15.87,15.87,0,0,0,4.89,6,11,11,0,0,0,4.84,2,8.32,8.32,0,0,0,1.42.1A1.68,1.68,0,0,0,110.14,136.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.15,191c.12,0,17,5.91,20.77,23.75s4,62.9-2.95,64.77-22.79,0-22.79,0l-12.61-52.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.34,193.6l-19.56,28.46a17.16,17.16,0,0,0-2.75,5.23c-.83,3.25.31,6.63,1.43,9.78l14.4,40.4,6.49,3a5.78,5.78,0,0,0,2.93-4.4,15,15,0,0,0-.44-5.45,91.17,91.17,0,0,0-4.29-14.27c-1.11-2.83-2.32-6.18-.65-8.71,1.28-1.94,3.75-2.59,5.71-3.83,4.37-2.76,6-8.37,6.25-13.53C185.56,217.58,180.4,205.33,175.34,193.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M185.7,267.76a2.67,2.67,0,0,1,.07-.68l.3-1.92c.15-.83.31-1.85.47-3s.39-2.54.56-4c.4-3,.74-6.56,1-10.54s.39-8.36.34-13-.34-9-.7-12.94-.85-7.53-1.35-10.51c-.22-1.49-.49-2.82-.71-4s-.41-2.19-.59-3l-.39-1.9a3.34,3.34,0,0,1-.1-.68,2.94,2.94,0,0,1,.2.65q.19.72.48,1.89t.69,3c.24,1.17.54,2.51.78,4,.55,3,1.05,6.54,1.47,10.52s.67,8.37.74,13-.11,9-.38,13-.68,7.57-1.13,10.56c-.19,1.5-.43,2.85-.63,4s-.38,2.2-.56,3-.3,1.42-.4,1.9A5.19,5.19,0,0,1,185.7,267.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.11,272.88a6,6,0,0,1-2,.33,20.6,20.6,0,0,1-9.43-1.61,6,6,0,0,1-1.74-1,51.33,51.33,0,0,0,6.45,1.8A54.24,54.24,0,0,0,191.11,272.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "99.22 161.75 114.59 153.59 135 154.33 147.45 158.71 128.43 170.76 118.05 172.72 99.22 162.36",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.78,237.86s-10.81,24.36-11.67,36,7,32.09,11.06,57.47c3.29,20.46,4.52,57.94,6.81,70.14s10.63,43.66,10.63,43.66l18.29,1.13s.06-83.61.06-93.54-.42-58.54-.42-58.54L158.19,373l12.07,75.3,21.27-1s-2.92-64-4-75.94c-1.61-17.65-8.94-82.47-12.38-93.82s-16.82-39.8-16.82-39.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.39,431.78l.47,20.94s21,7.84,21.25,11.72l-40.65-.07-.11-32.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3,450.94a1.66,1.66,0,0,0-1.15,1.89A1.59,1.59,0,0,0,179,454a1.75,1.75,0,0,0,1.21-2,1.65,1.65,0,0,0-2.07-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.46,464.37l.12-3.3,38.93,1.3s1.81.8,1.6,2.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52,452.52c0,.2-1,.28-2,.92s-1.5,1.47-1.69,1.39.12-1.22,1.32-2S191.57,452.34,191.52,452.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.78,454.29c.05.19-.81.53-1.49,1.36s-.87,1.73-1.07,1.72-.32-1.13.54-2.16S195.78,454.1,195.78,454.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.2,459.4c-.18,0-.46-1,.05-2s1.44-1.52,1.53-1.35-.49.74-.9,1.64S198.39,459.38,198.2,459.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.17,447.73c-.08.18-1-.1-2.11,0s-2,.42-2.1.25.74-.88,2.06-.94S191.27,447.57,191.17,447.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,429.28l.57,25.34-5.32,20.18a2.59,2.59,0,0,0,2,3.21h0a2.55,2.55,0,0,0,2.28-.67c3.87-3.71,18-17.42,17.89-19.27-.17-2.15,1.17-26.77,1.17-26.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.8,478,132,456.36v1.07A3.89,3.89,0,0,1,131,460c-1.61,1.9-6.17,7-16.88,17.38a2.57,2.57,0,0,1-2.36.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.77,448.18a1.57,1.57,0,0,0-.43,2.05,1.51,1.51,0,0,0,2,.44,1.64,1.64,0,0,0,.44-2.17,1.57,1.57,0,0,0-2.16-.23",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.6,466.94c-.15.07-.72-1.26-2.23-2a7.72,7.72,0,0,0-2.91-.56c0-.06.29-.26.89-.34a4,4,0,0,1,2.27.4,4.07,4.07,0,0,1,1.7,1.55C117.62,466.54,117.66,466.92,117.6,466.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.79,470.33a22,22,0,0,0-2.24-1.09,23.49,23.49,0,0,0-2.48-.32,2.89,2.89,0,0,1,2.63-.21C115.2,469.15,115.92,470.26,115.79,470.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,462.59a25.94,25.94,0,0,0-3.35-1.92,27.37,27.37,0,0,0-3.76-.88,7.1,7.1,0,0,1,7.11,2.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.43,454.87c-.07.15-1.47-.43-3.29-.5s-3.27.37-3.32.22a5,5,0,0,1,3.34-.78A5,5,0,0,1,121.43,454.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.45,447.43a12.39,12.39,0,0,0-3.42-.61,12.62,12.62,0,0,0-3.36.84c0-.05.24-.37.82-.71a5.66,5.66,0,0,1,5.09-.17C121.19,447.07,121.48,447.37,121.45,447.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.08,445.4a2.19,2.19,0,0,1,0-1,6.5,6.5,0,0,1,.76-2.51,2.94,2.94,0,0,1,1.26-1.41,1.05,1.05,0,0,1,1.18.23,1.72,1.72,0,0,1,.4,1.15,3.67,3.67,0,0,1-3.22,3.39,4.27,4.27,0,0,1-4.18-2.22,1.5,1.5,0,0,1-.07-1.23,1,1,0,0,1,1.07-.55,3.67,3.67,0,0,1,1.67.87,7.3,7.3,0,0,1,1.73,2,2.15,2.15,0,0,1,.39.88,11.49,11.49,0,0,0-2.36-2.53,3.34,3.34,0,0,0-1.47-.73.56.56,0,0,0-.59.3,1,1,0,0,0,.1.8,3.8,3.8,0,0,0,3.65,1.89,3.19,3.19,0,0,0,2.77-2.84,1.23,1.23,0,0,0-.25-.81.54.54,0,0,0-.64-.14,2.65,2.65,0,0,0-1.1,1.17A9.73,9.73,0,0,0,118.08,445.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.15,356.26c7.27,3.25,21.95,3.15,28.2-2.45C124.15,350.37,109.53,351.49,103.15,356.26Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.68,173.62s6.21-7.54,10.31-10.08a120,120,0,0,1,11.86-5.89s10.74,8.85,19.92,6a30.9,30.9,0,0,0,13.92-8.59l20.54,2.37s3.39,46.9,2,52.69-1.74,30.61-1.74,30.61L95.9,239.51l1.95-50.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.9 181.15 107.28 248.63 154.58 248.63 154.53 181.03 105.9 181.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.55,206.73a7.21,7.21,0,0,1-1.45-.27l-1.68-.4a15.31,15.31,0,0,1-2.19-.68,32.85,32.85,0,0,1-11.5-6.54l-1.44-1.29c-.46-.44-.87-.91-1.29-1.36-.87-.87-1.56-1.84-2.28-2.71a34.68,34.68,0,0,1-3.13-5.09,25.51,25.51,0,0,1-1.55-3.72,5.46,5.46,0,0,1-.36-1.43s.19.49.55,1.37a34.9,34.9,0,0,0,1.69,3.61,36.83,36.83,0,0,0,3.19,5c.71.85,1.4,1.81,2.26,2.66.42.43.83.89,1.28,1.32l1.42,1.27A34.59,34.59,0,0,0,148.35,205a16.43,16.43,0,0,0,2.15.75l1.65.48A8.57,8.57,0,0,1,153.55,206.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.25 197.68 103.36 245.38 142.28 245.38 140.65 197.16 102.25 197.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.28,245.2a1.43,1.43,0,0,1-.06-.46l0-1.34c0-1.24-.09-2.9-.16-4.92-.16-4.22-.38-9.92-.63-16.21s-.45-12.08-.48-16.23c0-2.08,0-3.77,0-4.93,0-.53,0-1,0-1.34a2.43,2.43,0,0,1,0-.46,1.43,1.43,0,0,1,.06.46c0,.37,0,.81,0,1.34,0,1.25.09,2.91.16,4.92.16,4.23.38,9.92.63,16.22s.45,12.07.48,16.23c0,2.08,0,3.76,0,4.92,0,.53,0,1,0,1.34A1.7,1.7,0,0,1,106.28,245.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.28,
    y: 205.4,
    width: 19.25,
    height: 6.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.77,174c.41-.09,8.08,41.35,8.08,48.12s-.83,15-8.91,16.94-59.66-2.57-59.66-2.57l17.31-11.22,10.24-.88,24.6-3.7-4.61-34.15S167.76,175.08,172.77,174Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.87,226.47a11.35,11.35,0,0,1-.54-1.35,7.15,7.15,0,0,0-5.16-4.06,12.62,12.62,0,0,1-1.44-.21,2.72,2.72,0,0,1,1.49-.16,6.4,6.4,0,0,1,3.34,1.36,6.47,6.47,0,0,1,2.12,2.94A2.55,2.55,0,0,1,170.87,226.47Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,157s7.27-.12,12.29,4.32S175.14,177,175.14,177l-15.88,11.47Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.77,186.36,98.71,193,94,163.54S80,168.81,77.77,186.36Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.09,176.54a13.75,13.75,0,0,1,.89,2.4c.55,1.67,1.21,3.65,1.94,5.84l2,5.82a14.71,14.71,0,0,1,.76,2.44,10.91,10.91,0,0,1-1.11-2.31c-.61-1.46-1.4-3.5-2.17-5.78s-1.4-4.38-1.8-5.91A11.57,11.57,0,0,1,93.09,176.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.49,156.45l9.79,64.74,3.15-.54L160.28,157S152.35,154.68,151.49,156.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.37,208.92l-46,8.41-.85-24.7-19-5.82c-1.23,11.36,1.13,47.18,5.89,49.64s18.57,2.45,26.86,0S144.54,222,144.54,222Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.83,210.91l5.54-2a40.17,40.17,0,0,1,4.28-5.66c2-2,13.75-6.81,13.75-6.81s2.93.35.72,3.1a18.22,18.22,0,0,1-4,3.85s3.17.28,3.77,1.14.17,3.86-.09,4.8a7.27,7.27,0,0,1,0,5.06l-.08.78s.34,1.88-1.8,3.85c0,0,.85,1.76-1.38,2.51s-16.2.5-16.2.5Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.34,222s.12,0,.36,0l1.05,0,4,0c1.71,0,3.79-.05,6.16-.15,1.18-.06,2.44-.11,3.74-.29a3.2,3.2,0,0,0,1.75-.68,1.45,1.45,0,0,0,.32-1.68l-.07-.16.12-.12a6,6,0,0,0,1.27-1.63,3.59,3.59,0,0,0,.44-2v-.07c0-.24.06-.51.09-.77v-.07a7,7,0,0,0,0-4.86l0-.09,0-.08a14,14,0,0,0,.37-2.69,6.24,6.24,0,0,0-.06-1.37,1.38,1.38,0,0,0-.21-.55,1.46,1.46,0,0,0-.49-.34,11.31,11.31,0,0,0-3.07-.68l-.7-.08.59-.39a18.67,18.67,0,0,0,3.6-3.38,4,4,0,0,0,1.11-1.93c.09-.67-.65-1.09-1.32-1.18l.12,0c-3,1.26-5.84,2.48-8.3,3.64-1.23.58-2.37,1.15-3.41,1.72a8.51,8.51,0,0,0-2.57,1.92,39.45,39.45,0,0,0-2.86,3.63l-.72,1a2.29,2.29,0,0,1-.26.34s0-.14.19-.38.36-.6.66-1a32.81,32.81,0,0,1,2.77-3.74,8.79,8.79,0,0,1,2.61-2c1-.59,2.19-1.18,3.41-1.78,2.46-1.19,5.25-2.44,8.3-3.72l.06,0h.06a2.74,2.74,0,0,1,1.18.47,1.41,1.41,0,0,1,.58,1.24,4.53,4.53,0,0,1-1.22,2.22,19.1,19.1,0,0,1-3.72,3.49l-.11-.48a11.81,11.81,0,0,1,3.24.72,1.81,1.81,0,0,1,.68.49,1.83,1.83,0,0,1,.31.78,6.74,6.74,0,0,1,.07,1.48,14.53,14.53,0,0,1-.39,2.8v-.17a7.47,7.47,0,0,1,0,5.25l0-.06c0,.27-.06.53-.09.77v-.07a5.07,5.07,0,0,1-1.89,4.07l.05-.27a1.89,1.89,0,0,1-.43,2.22,3.62,3.62,0,0,1-2,.78c-1.34.17-2.6.2-3.79.25-2.38.06-4.46,0-6.17,0s-3.07-.05-4-.08l-1.05,0A2,2,0,0,1,144.34,222Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.74,226.41a3.24,3.24,0,0,1-.18-1.56A8.93,8.93,0,0,1,98,218.24c.78-.59,1.35-.81,1.38-.75a11.35,11.35,0,0,0-4.62,8.92Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.27,222.13a8.91,8.91,0,0,1-1.47.89c-1,.55-2.38,1.3-4.14,2.19-3.53,1.8-8.49,4.11-14.11,6.35s-10.81,3.94-14.61,5.06c-1.9.56-3.44,1-4.52,1.25a11.71,11.71,0,0,1-1.68.37,9.65,9.65,0,0,1,1.63-.57l4.46-1.4c3.76-1.21,8.93-3,14.53-5.2s10.57-4.48,14.13-6.19l4.22-2A12.92,12.92,0,0,1,144.27,222.13Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.73,159.42c2.63,5.45,2.17,11.13-1,12.67s-7.94-1.62-10.57-7.07-2.16-11.13,1-12.68S114.1,154,116.73,159.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.09,163.87c1.43,3.75,1,7.4-1,8.16s-4.76-1.66-6.2-5.41-1-7.39,1-8.15S108.66,160.13,110.09,163.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.93,159.91c-1.85-5.76-.6-11.32,2.79-12.41s7.64,2.71,9.49,8.48.59,11.32-2.8,12.41S136.78,165.68,134.93,159.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.13,156.43c-.9-3.91.05-7.47,2.12-7.94s4.49,2.3,5.39,6.21-.06,7.46-2.13,7.94S143,160.33,142.13,156.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.49,161.49s-5.15-6.71-4.65-9.82,9-10.2,9-10.2l.55,4.9s-6.44,2.34-6.23,5.59,3.06,8.6,3.06,8.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62,171.74a10.61,10.61,0,0,0,.93-2.37,7.82,7.82,0,0,0,.07-2.72,11.59,11.59,0,0,0-1-3.2,16,16,0,0,0-1.75-2.9,4.48,4.48,0,0,0-2.15-1.55,3.16,3.16,0,0,0-1.78,0c-.42.13-.62.28-.65.24s.15-.23.58-.43a3,3,0,0,1,2-.13,4.58,4.58,0,0,1,2.41,1.6,14.44,14.44,0,0,1,1.86,3,11.22,11.22,0,0,1,1,3.36,7.78,7.78,0,0,1-.19,2.88,5.83,5.83,0,0,1-.81,1.76C109.84,171.59,109.64,171.76,109.62,171.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5,171.36a6.31,6.31,0,0,0,1.11-2.78c.31-1.86-.49-4.42-1.47-7.13a11.06,11.06,0,0,0-2-3.46,6.14,6.14,0,0,0-2.68-1.74,5.33,5.33,0,0,0-3,0s.23-.21.76-.36a4.48,4.48,0,0,1,2.31,0,6.23,6.23,0,0,1,2.93,1.78,10.75,10.75,0,0,1,2.12,3.6,31.4,31.4,0,0,1,1.21,4,8.73,8.73,0,0,1,.15,3.41A3.91,3.91,0,0,1,112.5,171.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.09,161.45s-.18.16-.58.23a2.77,2.77,0,0,1-1.69-.35,4.86,4.86,0,0,1-1.73-1.85,14.06,14.06,0,0,1-1.83-8.28,3.3,3.3,0,0,1,.64-1.58c.27-.32.48-.41.5-.39a3.81,3.81,0,0,0-.78,2,15.18,15.18,0,0,0,.73,5.29c.66,2,1.52,3.78,2.66,4.48A3.23,3.23,0,0,0,148.09,161.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.41,165.73s-.24.26-.84.43A4,4,0,0,1,144,166a7.08,7.08,0,0,1-2.92-2.5,17.74,17.74,0,0,1-2.2-4.13c-1.14-3.1-1.51-6.25-.67-8.36a4.83,4.83,0,0,1,1.5-2.11c.48-.39.82-.49.83-.46s-.28.2-.7.61a5.24,5.24,0,0,0-1.29,2.08c-.69,2-.29,5,.81,8.06s2.85,5.62,4.78,6.47a4.17,4.17,0,0,0,2.4.34C147.1,165.86,147.39,165.69,147.41,165.73Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.799339628b6deae3ed584df088e0ebdb.svg";
export { ForwardRef as ReactComponent };